<template>
  <!-- 請求書管理（売上） -->
  <div id="sales_management">
    <CCard>
      <CCardHeader>
        <h2>請求書管理</h2>
      </CCardHeader>

      <!-- 検索（サンプル画面と同じ） -->
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th></th>
          </tr>
          <tr>
            <td>
              <select class="custom-select preika-control--year" v-model="year">
                <option v-for="option in yearOption" :value="option.id" :key="option.id">
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="custom-select preika-control--month" v-model="month">
                <option v-for="option in monthOption" :value="option.id" :key="option.id">
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>請求書</td>
            <td>
              <button class="btn btn-primary" @click="callList">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>

      <!--
        断られた理由の置き場。

        **検索結果の内側（callFlg）に置くと、検索そのものが失敗したときに
        表示先ごと消えて、理由がどこにも出ない。**代入する側だけ直しても
        画面には出ないので、ここは callFlg の外に出しておく。
      -->
      <CCardBody v-if="errors.length" class="py-0">
        <div class="alert alert-danger mb-0" role="alert">
          <div v-for="e in errors" :key="e">{{ e }}</div>
        </div>
      </CCardBody>

      <!--
        済んだことの知らせ。取り消したあと（次に押すもの＝［更新］か［発行］を言う）と、
        再作成の［登録］で、発行済みのため入れ替えなかった明細があったとき。検索し直すと消える。
      -->
      <CCardBody v-if="notice" class="py-0">
        <div class="alert alert-success mb-0 sales-notice" role="status">{{ notice }}</div>
      </CCardBody>

      <!-- ここから下は「検索後に表示」 -->
      <template v-if="callFlg">
        <CCardHeader>
          <strong v-if="showYearMonth" style="font-size: 20px; font-weight: bold;">
            {{ selectYear }} 年 {{ selectMonth }} 月
          </strong>
        </CCardHeader>

        <!-- 1) 未登録：検索後に新規フォーム -->
        <CCardBody v-if="mode === 'new'">
          <CCardHeader><strong>新規登録</strong></CCardHeader>

          <div class="table-responsive" v-if="formRows.length">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th rowspan="2" class="text-center">発行</th>
                  <th rowspan="2">スタッフ名</th>
                  <th rowspan="2">会社名</th>
                  <!--
                    発行ONの行だけ必須。CInput の label 属性では印を出せないので、
                    見出しへ直接書く。**発行OFFまで必須にすると締めが止まる。**
                  -->
                  <th rowspan="2" class="text-center">支払期限<span class="asterisk">*</span></th>
                  <th rowspan="2">プロジェクト名</th>
                  <th rowspan="2">項目補足</th>
                  <th rowspan="2" class="text-center">下限</th>
                  <th rowspan="2" class="text-center">上限</th>
                  <th colspan="3" class="text-center">単価（円）</th>
                  <th rowspan="2" class="text-center">精算（H）</th>
                  <th rowspan="2" class="text-center">売上（円）</th>
                  <th rowspan="2">その他経費</th>
                  <th rowspan="2">備考</th>
                </tr>
                <tr>
                  <th class="text-center">単価</th>
                  <th class="text-center">控除</th>
                  <th class="text-center">超過</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(r, idx) in formRows" :key="formRowKey(r, idx)">
                  <td class="text-center">
                    <label class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        v-model="r.is_invoiced"
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                  <td>{{ r.user_name }}</td>
                  <td v-if="r._showFormCompany" :rowspan="r._formCompanySpan">
                    {{ r.company_name }}
                  </td>
                  <td v-if="r._showFormDueDate" :rowspan="r._formDueDateSpan" class="cell-date">
                    <CInput type="date" v-model="r.due_date" @input="onCompanyDueDateInput(r)" />
                  </td>
                  <td v-if="r._showFormProject" :rowspan="r._formProjectSpan">
                    <CInput v-model="r.project_name" @input="onProjectNameInput(r)" class="project-name-input" />
                  </td>
                  <td class="cell-staff"><CInput v-model="r.staff_name" /></td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_min" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_max" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price" @input="onBaseOrUnit(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_deduct" @input="onDeductInput(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_excess" @input="onExcessInput(r)" />
                  </td>

                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.settlement_time" @input="onSettlementInput(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.amount_sales" @input="onSalesInput(r)" />
                  </td>
                  <td class="cell-other-expenses">
                    <div
                      v-for="(ex, exIdx) in r.other_expenses"
                      :key="expenseRowKey(r, exIdx)"
                      class="expense-row"
                    >
                      <CInput class="expense-item" v-model="ex.item_name" placeholder="項目名" />
                      <CInput class="expense-qty text-right" v-model="ex.qty" placeholder="数量" />
                      <CInput class="expense-unit" v-model="ex.unit" placeholder="単位" />
                      <CInput class="expense-price text-right" v-model="ex.unit_price" placeholder="単価" />
                      <CInput class="expense-amount text-right" v-model="ex.amount" placeholder="金額" />
                      <CInput class="expense-remarks" v-model="ex.remarks" placeholder="備考" />
                      <button type="button" class="btn btn-danger btn-sm ml-1" @click="removeOtherExpense(r, exIdx)">削除</button>
                    </div>
                    <button type="button" class="btn btn-info btn-sm mt-1" @click="addOtherExpense(r)">追加</button>
                  </td>
                  <td v-if="r._showFormRemarks" :rowspan="r._formRemarksSpan" class="cell-remarks">
                    <textarea
                      v-model="r.remarks"
                      @input="onCompanyRemarksInput(r)"
                      class="form-control remarks-textarea"
                      rows="4"
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!--
            対象行が0件でも表を消すだけだと、見出しと押せない登録ボタンだけの
            白い画面になる。**データが無いのか、金額設定をしていないのか、
            権限が足りないのかが区別できない。**次の一手を名指しする。
          -->
          <div v-else class="preika-empty-state">
            <div>
              <strong>対象月の請求対象がありません</strong>
              <p>プロジェクトへの所属と、プロジェクト金額設定（対象年月）を確認してください。</p>
            </div>
          </div>

          <CAlert v-if="missingFields.length" color="warning" class="mb-3">
            <b>あと{{ missingFields.length }}項目直すと、{{ saveActionName }}へ進めます。</b>
            <ul class="mb-0 mt-2">
              <li v-for="what in missingFields" :key="what">{{ what }}</li>
            </ul>
            <!--
              金額設定が未登録の人がいるとき。直す先は別の画面（プロジェクト金額設定）なので、
              文で名前を言うだけにせず、その月の画面へ行けるリンクを置く。開けない人には出さない。
            -->
            <router-link
              v-if="rateUnsetMembers.length > 0 && canOpenProjectRate"
              class="d-inline-block mt-2 rate-setting-link"
              :to="{ path: projectRatePath, query: { year: String(selectYear), month: String(selectMonth) } }"
            >{{ invoiceTexts.openRateSetting }}</router-link>
          </CAlert>

          <div class="text-center mt-3">
            <button class="btn btn-secondary mr-2" :disabled="saving" @click="cancelToNone">キャンセル</button>
            <!--
              押せない条件は、上の一覧（missingFields）と同じ computed を見る。
              **`length > 0` と書くのは冗長ではない。**Vue は disabled のような
              真偽属性を「null か false のときだけ」外すので、`length` の
              0 をそのまま渡すと**理由が1つも無いのに押せないまま**になる。
            -->
            <button
              class="btn btn-primary"
              :disabled="saving || !formRows.length || unreadableNumbers.length > 0 || dueDateMissingCompanies.length > 0 || rateUnsetMembers.length > 0"
              @click="saveNew"
            >登録</button>
          </div>
        </CCardBody>

        <!-- 2) 登録済：参照（請求書ボタンあり）＋更新ボタン -->
        <CCardBody v-else-if="mode === 'view'">
          <!--
            **請求書を出力・発行できる人（canOutputAndIssueInvoice）にだけ出すもの。**

            この画面は「売上情報の管理」だけでも開けるが、請求書を出す口（PDF・ZIP）と
            発行の口は、契約に請求書の機能があり「請求書の管理」を持つ人しか通らない
            （サーバの決まり）。持たない人に［請求書］［一括ダウンロード］を見せると、
            押すたびに必ず断られる（2026-10-09、画面の確かめで見つかった。前からの動き）。

            出し分けるのは次の4つ。判定は1つ（accessPolicy.js の同じ関数）。
              ・下の黄色い案内（「このまま請求書を出すと…」と言う文。出せない人には当てはまらない）
              ・その下の説明（［請求書］と［発行］の使い分け）
              ・表の中の［請求書］［発行］（会社・プロジェクト・スタッフの3か所）
              ・会社名の見出しの［一括ダウンロード］［一括発行］
            **発行の状態（発行済みの番号と発行日・未発行）は、全員に出す。**
          -->

          <!--
            請求書に載せる自社の情報（住所・インボイス登録番号・振込先）が空のとき。
            **空のまま請求書を出して、気づかないことを防ぐ。**発行は止めない。
            入れる場所は自社設定。開ける人にはリンク、開けない人には頼む相手を書く。
          -->
          <CAlert
            v-if="canOutputAndIssueInvoice && issuerMissingLabels.length"
            color="warning"
            class="mb-2 issuer-missing"
          >
            <div>{{ issuerMissingNotice }}</div>
            <router-link
              v-if="canOpenCompanySetting"
              :to="{ name: '自社設定の請求書記載情報' }"
            >{{ issuerTexts.whereToSet }}</router-link>
            <div v-else>{{ issuerTexts.askAdmin }}</div>
          </CAlert>

          <!--
            ［請求書］（確認用）と［発行］（番号と日付を決める）の違い。
            書いておかないと、未発行の紙に番号と日付が無い理由が分からない。
            どちらのボタンも出ない人には出さない（使えない操作の説明になる）。
          -->
          <p v-if="canOutputAndIssueInvoice" class="invoice-guide">{{ invoiceTexts.guide }}</p>

          <!--
            合計・（作り直す分が無かったときは）そのこと・［最新を取り込んで再作成］・［更新］。PC の幅では横1行。
            スマホ幅では横に詰めると合計の字が1〜2字ずつに折り返すので、縦に積む（下の scoped CSS）。
          -->
          <div class="d-flex justify-content-end align-items-center mb-2 sales-summary-row">
            <div class="mr-3 text-right">
              <div>単価合計：{{ formatNum(totalUnitPrice) }}</div>
              <div>売上合計：{{ formatNum(totalAmountSales) }}</div>
            </div>
            <!--
              売上の行を書く2つのボタン。**登録・更新できる人（canEditSales）にだけ出す。**
              「請求書の管理」だけの人に出すと、押して入力したあとで必ず断られる
              （サーバは「売上情報の管理」を求める）。合計の数字は全員に出す。
            -->
            <!--
              ［最新を取り込んで再作成］は、**発行した請求書がある月でも出す。**
              押すと、まだ発行していない分だけを最新の実績・金額設定で作り直した表が出る
              （この時点では何も消えない）。発行した請求書に載っている行は、変えられない行として
              同じ表に見える。中身を見て［登録］を押すと、そこで初めて入れ替わる。

              押したが、作り直す分が1つも無かったとき（全部が発行済みで、最新に増えた分も無い）は、
              表を開かずに、ボタンの横にそのことを出す。
            -->
            <template v-if="canEditSales">
              <span v-if="recreateNothing" class="recreate-nothing mr-2" role="status">{{ invoiceTexts.recreateNothing }}</span>
              <button
                class="btn btn-warning mr-2"
                :disabled="saving"
                @click="recreateLatest"
              >最新を取り込んで再作成</button>
              <button class="btn btn-primary" @click="startEdit">更新</button>
            </template>
          </div>

          <!--
            上の表は「まだ発行していない分」。発行した請求書に載っていない行だけを、
            会社・プロジェクト・スタッフの3段で出す。発行した請求書は、下の表に1枚ずつ出す。
          -->
          <h5 class="sales-section-title">{{ invoiceTexts.unissuedHeading }}</h5>
          <div class="table-responsive">
            <table class="table table-bordered unissued-table">
              <thead>
                <tr>
                  <th rowspan="2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span>会社名</span>
                      <div v-if="canOutputAndIssueInvoice" class="invoice-actions">
                        <button
                          class="btn btn-info btn-sm ml-2"
                          :disabled="downloadingInvoice !== ''"
                          :aria-busy="downloadingInvoice === 'zip' ? 'true' : 'false'"
                          @click="downloadAllCompanyInvoices"
                        >
                          <span v-if="downloadingInvoice === 'zip'" class="my-spinner" aria-hidden="true"></span>
                          {{ downloadingInvoice === 'zip' ? invoiceTexts.downloading : '一括ダウンロード' }}
                        </button>
                        <!--
                          未発行の会社を、まとめて発行する。
                          未発行の会社が無ければ押せない。
                        -->
                        <button
                          class="btn btn-primary btn-sm ml-2"
                          :disabled="issuing || unissuedCompanyIds.length === 0"
                          @click="issueAllCompanyInvoices"
                        >{{ invoiceTexts.issueAll }}</button>
                      </div>
                    </div>
                  </th>
                  <th rowspan="2">支払期限</th>
                  <th rowspan="2">プロジェクト名</th>
                  <th rowspan="2">項目補足</th>
                  <th colspan="3" class="text-center">単価（円）</th>
                  <th rowspan="2" class="text-center">精算時間（H）</th>
                  <th rowspan="2" class="text-center">売上（円）</th>
                  <th rowspan="2">その他経費</th>
                  <th rowspan="2">備考</th>
                </tr>
                <tr>
                  <th class="text-center">単価</th>
                  <th class="text-center">控除</th>
                  <th class="text-center">超過</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(r, idx) in viewRows" :key="rowKey(r, idx)">
                  <td v-if="r._showCompany" :rowspan="r._companySpan">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span>{{ r.company_name }}</span>
                      </div>
                      <div v-if="canOutputAndIssueInvoice" class="invoice-actions">
                        <!--
                          ［請求書］は、押すとファイルを受け取るだけで画面は変わらない。受け取るまでのあいだ、
                          押したボタンを「処理中」の見た目にし、ほかの［請求書］［一括ダウンロード］も押せなくする
                          （押せたのかが分からず、続けて押して同じファイルを何度も受け取っていた。2026-10-11）。
                          プロジェクト・スタッフの欄も同じ。
                        -->
                        <button
                          class="btn btn-info btn-sm ml-2"
                          :disabled="downloadingInvoice !== ''"
                          :aria-busy="isDownloadingInvoice('company', r.company_id) ? 'true' : 'false'"
                          @click="openInvoice('company', r.company_id)"
                        >
                          <span v-if="isDownloadingInvoice('company', r.company_id)" class="my-spinner" aria-hidden="true"></span>
                          {{ isDownloadingInvoice('company', r.company_id) ? invoiceTexts.downloading : '請求書' }}
                        </button>
                        <button
                          class="btn btn-primary btn-sm ml-2"
                          :disabled="issuing"
                          @click="issueInvoice('company', r.company_id)"
                        >{{ invoiceTexts.issue }}</button>
                      </div>
                    </div>
                    <!-- この表にあるのは、まだ発行していない分。発行すると、下の「発行した請求書」へ移る。 -->
                    <div class="invoice-state">{{ invoiceTexts.unissued }}</div>
                  </td>

                  <td v-if="r._showDueDate" :rowspan="r._dueDateSpan" class="text-center">
                    {{ r.due_date ? r.due_date.replace(/-/g, "/") : "" }}
                  </td>

                  <td v-if="r._showProject" :rowspan="r._projectSpan">
                    <div class="d-flex align-items-center justify-content-between">
                      <span>{{ r.project_name }}</span>
                      <div v-if="canOutputAndIssueInvoice" class="invoice-actions">
                        <button
                          class="btn btn-info btn-sm ml-2"
                          :disabled="downloadingInvoice !== ''"
                          :aria-busy="isDownloadingInvoice('project', r.project_id) ? 'true' : 'false'"
                          @click="openInvoice('project', r.project_id)"
                        >
                          <span v-if="isDownloadingInvoice('project', r.project_id)" class="my-spinner" aria-hidden="true"></span>
                          {{ isDownloadingInvoice('project', r.project_id) ? invoiceTexts.downloading : '請求書' }}
                        </button>
                        <button
                          class="btn btn-primary btn-sm ml-2"
                          :disabled="issuing"
                          @click="issueInvoice('project', r.project_id)"
                        >{{ invoiceTexts.issue }}</button>
                      </div>
                    </div>
                    <div class="invoice-state">{{ invoiceTexts.unissued }}</div>
                  </td>

                  <td>
                    <div class="d-flex align-items-center justify-content-between">
                      <span>{{ r.staff_name }}</span>
                      <div v-if="canOutputAndIssueInvoice" class="invoice-actions">
                        <button
                          class="btn btn-info btn-sm ml-2"
                          :disabled="downloadingInvoice !== ''"
                          :aria-busy="isDownloadingInvoice('user', r.user_id, r._invoiceCompanyId) ? 'true' : 'false'"
                          @click="openInvoice('user', r.user_id, r._invoiceCompanyId)"
                        >
                          <span v-if="isDownloadingInvoice('user', r.user_id, r._invoiceCompanyId)" class="my-spinner" aria-hidden="true"></span>
                          {{ isDownloadingInvoice('user', r.user_id, r._invoiceCompanyId) ? invoiceTexts.downloading : '請求書' }}
                        </button>
                        <button
                          class="btn btn-primary btn-sm ml-2"
                          :disabled="issuing"
                          @click="issueInvoice('user', r.user_id, r._invoiceCompanyId)"
                        >{{ invoiceTexts.issue }}</button>
                      </div>
                    </div>
                    <div class="invoice-state">{{ invoiceTexts.unissued }}</div>
                  </td>

                  <td class="text-right">{{ formatNum(r.unit_price) }}</td>
                  <td class="text-right">{{ formatNum(r.unit_price_deduct) }}</td>
                  <td class="text-right">{{ formatNum(r.unit_price_excess) }}</td>
                  <td class="text-right">{{ formatNum(r.settlement_time) }}</td>
                  <td class="text-right">{{ formatNum(r.amount_sales) }}</td>
                  <td class="cell-other-expenses">
                    <div v-if="r.other_expenses && r.other_expenses.length">
                      <div
                        v-for="(ex, exIdx) in r.other_expenses"
                        :key="expenseRowKey(r, exIdx)"
                        class="expense-view-row"
                      >
                        <div>
                          【{{ ex.item_name || "—" }}】
                          {{ formatNum(ex.unit_price) }}円 X {{ formatNum(ex.qty) }}{{ ex.unit || "" }}
                          = {{ formatNum(ex.amount) }}円
                        </div>
                        <div v-if="ex.remarks">{{ ex.remarks }}</div>
                      </div>
                    </div>
                    <div v-else>—</div>
                  </td>
                  <td v-if="r._showViewRemarks" :rowspan="r._viewRemarksSpan">
                    {{ r.remarks }}
                  </td>
                </tr>
                <!-- 全部発行済みの月。表を消さずに（一括ダウンロードは見出しにある）、無いことを言う。 -->
                <tr v-if="viewRows.length === 0" class="no-unissued">
                  <td colspan="11" class="text-center">{{ invoiceTexts.noUnissued }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCardBody>

        <!--
          3) 更新と、再作成（最新を取り込んで作り直した表）。同じ表を使う。

          再作成の表は、サーバが返したもの：発行した請求書に載っている行は、いまの値のままの
          変えられない行。それ以外は、最新の実績・金額設定で作り直した行（「発行」の入切・
          項目補足・精算・その他経費・備考は、前の行から引き継いである）。
          **この表を見ているあいだは、まだ何も入れ替わっていない。**［登録］で入れ替わる。
        -->
        <CCardBody v-else-if="mode === 'edit' || mode === 'recreate'">
          <CCardHeader><strong>{{ mode === 'recreate' ? '最新を取り込んで再作成' : '更新' }}</strong></CCardHeader>
          <p v-if="mode === 'recreate'" class="invoice-guide recreate-guide">{{ invoiceTexts.recreateGuide }}</p>
          <!--
            ［登録］で削除される未発行の明細（当月除外など、作り直した表に入らない明細）。気づかずに
            消さないよう、表の上に名前で並べる（監査 RC-2。文は Gemini の Z1・Z2）。
          -->
          <CAlert v-if="mode === 'recreate' && recreateRemoved.length" color="warning" class="recreate-removed">
            <p class="mb-1">{{ invoiceTexts.recreateRemovedGuide }}</p>
            <ul class="recreate-removed-list mb-0">
              <li v-for="gone in recreateRemoved" :key="gone.sales_id">{{ invoiceTexts.recreateRemovedLine(gone.company_name, gone.project_name, gone.user_name) }}</li>
            </ul>
          </CAlert>

          <div class="table-responsive" v-if="formRows.length">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th rowspan="2" class="text-center">発行</th>
                  <th rowspan="2">スタッフ名</th>
                  <th rowspan="2">会社名</th>
                  <!--
                    発行ONの行だけ必須。CInput の label 属性では印を出せないので、
                    見出しへ直接書く。**発行OFFまで必須にすると締めが止まる。**
                  -->
                  <th rowspan="2" class="text-center">支払期限<span class="asterisk">*</span></th>
                  <th rowspan="2">プロジェクト名</th>
                  <th rowspan="2">項目補足</th>
                  <th rowspan="2" class="text-center">下限</th>
                  <th rowspan="2" class="text-center">上限</th>
                  <th colspan="3" class="text-center">単価（円）</th>
                  <th rowspan="2" class="text-center">精算（H）</th>
                  <th rowspan="2" class="text-center">売上（円）</th>
                  <th rowspan="2">その他経費</th>
                  <th rowspan="2">処理フロー</th>
                </tr>
                <tr>
                  <th class="text-center">単価</th>
                  <th class="text-center">控除</th>
                  <th class="text-center">超過</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(r, idx) in formRows" :key="formRowKey(r, idx)">
                  <td class="text-center">
                    <label class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        v-model="r.is_invoiced"
                        :disabled="isOnInvoice(r)"
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                  <td>
                    {{ r.user_name }}
                    <!--
                      発行した請求書に載っている行。紙に出る項目は入力できない（備考は直せる）。
                      なぜ入力できないかと、直すには何をするかを、その行に出す。
                    -->
                    <div v-if="isOnInvoice(r)" class="locked-row-note">{{ invoiceTexts.lockedRow(r.invoice_no) }}</div>
                  </td>
                  <td v-if="r._showFormCompany" :rowspan="r._formCompanySpan">
                    {{ r.company_name }}
                  </td>
                  <td v-if="r._showFormDueDate" :rowspan="r._formDueDateSpan" class="cell-date">
                    <!--
                      支払期限は、会社でまとめた1つの欄。その会社に未発行の行が1つでもあれば入力でき、
                      入れた値は未発行の行にだけ入る（発行済みの行は元の値のまま送る）。
                      欄に出すのは未発行の行の値。全部が発行済みのときだけ、入力できない。
                    -->
                    <CInput type="date" v-model="dueDateRow(r).due_date" :disabled="dueDateLocked(r)" @input="onCompanyDueDateInput(r)" />
                  </td>
                  <td v-if="r._showFormProject" :rowspan="r._formProjectSpan">
                    <!-- プロジェクト名も同じ（プロジェクトでまとめた1つの欄。未発行の行にだけ入る）。 -->
                    <CInput v-model="projectNameRow(r).project_name" :disabled="projectNameLocked(r)" @input="onProjectNameInput(r)" class="project-name-input" />
                  </td>
                  <td class="cell-staff"><CInput v-model="r.staff_name" :disabled="isOnInvoice(r)" /></td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_min" :disabled="isOnInvoice(r)" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_max" :disabled="isOnInvoice(r)" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price" :disabled="isOnInvoice(r)" @input="onBaseOrUnit(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_deduct" :disabled="isOnInvoice(r)" @input="onDeductInput(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_excess" :disabled="isOnInvoice(r)" @input="onExcessInput(r)" />
                  </td>

                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.settlement_time" :disabled="isOnInvoice(r)" @input="onSettlementInput(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.amount_sales" :disabled="isOnInvoice(r)" @input="onSalesInput(r)" />
                  </td>
                  <td class="cell-other-expenses">
                    <div
                      v-for="(ex, exIdx) in r.other_expenses"
                      :key="expenseRowKey(r, exIdx)"
                      class="expense-row"
                    >
                      <CInput class="expense-item" v-model="ex.item_name" :disabled="isOnInvoice(r)" placeholder="項目名" />
                      <CInput class="expense-qty text-right" v-model="ex.qty" :disabled="isOnInvoice(r)" placeholder="数量" />
                      <CInput class="expense-unit" v-model="ex.unit" :disabled="isOnInvoice(r)" placeholder="単位" />
                      <CInput class="expense-price text-right" v-model="ex.unit_price" :disabled="isOnInvoice(r)" placeholder="単価" />
                      <CInput class="expense-amount text-right" v-model="ex.amount" :disabled="isOnInvoice(r)" placeholder="金額" />
                      <!-- 経費の備考は紙に出ないので、更新では載っている行でも直せる。再作成は載っている行を入れ直さないので、止める。 -->
                      <CInput class="expense-remarks" v-model="ex.remarks" :disabled="recreateKeepsRow(r)" placeholder="備考" />
                      <button type="button" class="btn btn-danger btn-sm ml-1" :disabled="isOnInvoice(r)" @click="removeOtherExpense(r, exIdx)">削除</button>
                    </div>
                    <button type="button" class="btn btn-info btn-sm mt-1" :disabled="isOnInvoice(r)" @click="addOtherExpense(r)">追加</button>
                  </td>
                  <td v-if="r._showFormRemarks" :rowspan="r._formRemarksSpan" class="cell-remarks">
                    <!--
                      備考は、会社でまとめた1つの欄。再作成は、発行した請求書に載っている行を入れ直さない
                      ので、載っている行がある会社の備考は、前のまま引き継ぐだけにする（ここで変えると、
                      同じ会社の中で備考が食い違う）。直すのは［更新］で（全部の行に入る）。
                    -->
                    <textarea
                      v-model="r.remarks"
                      :disabled="recreateKeepsCompanyRemarks(r)"
                      @input="onCompanyRemarksInput(r)"
                      class="form-control remarks-textarea"
                      rows="4"
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 新規と同じ理由。0件のまま白い画面にしない。 -->
          <div v-else class="preika-empty-state">
            <div>
              <strong>対象月の請求対象がありません</strong>
              <p>プロジェクトへの所属と、プロジェクト金額設定（対象年月）を確認してください。</p>
            </div>
          </div>

          <CAlert v-if="missingFields.length" color="warning" class="mb-3">
            <b>あと{{ missingFields.length }}項目直すと、{{ saveActionName }}へ進めます。</b>
            <ul class="mb-0 mt-2">
              <li v-for="what in missingFields" :key="what">{{ what }}</li>
            </ul>
            <!-- 新規と同じ。再作成の表で、金額設定が未登録の人がいるときに、直す先へ行けるリンク。 -->
            <router-link
              v-if="rateUnsetMembers.length > 0 && canOpenProjectRate"
              class="d-inline-block mt-2 rate-setting-link"
              :to="{ path: projectRatePath, query: { year: String(selectYear), month: String(selectMonth) } }"
            >{{ invoiceTexts.openRateSetting }}</router-link>
          </CAlert>

          <div class="text-center mt-3">
            <!-- 再作成の表でも同じ。やめれば、一覧へ戻るだけ（まだ何も入れ替わっていない）。 -->
            <button class="btn btn-secondary mr-2" :disabled="saving" @click="cancelEdit">キャンセル</button>
            <!--
              新規と同じ条件。`length > 0` を外すと 0 でも押せなくなる。
              再作成の表は、作り直す行が0件でも、差し替える未発行の明細があれば押せる（全部を当月除外にした
              など。［登録］でその明細を取り除く。監査 RC-2）。
            -->
            <button
              class="btn btn-primary"
              :disabled="saving || !hasSomethingToSave || unreadableNumbers.length > 0 || dueDateMissingCompanies.length > 0 || rateUnsetMembers.length > 0"
              @click="saveForm"
            >{{ saveActionName }}</button>
          </div>
        </CCardBody>

        <!--
          4) 未登録の月を、登録できない人（「売上情報の管理」を持たない人）が検索したとき。
          新規登録の表の代わりに、まだ登録されていないことと、登録するのは誰かを出す。
          **白い画面にしない。**何も出さないと、検索が効いたのか、データが無いのかが分からない。
        -->
        <CCardBody v-else-if="mode === 'unregistered'">
          <div class="preika-empty-state sales-unregistered">
            <div>
              <strong>{{ invoiceTexts.unregisteredTitle }}</strong>
              <p>{{ invoiceTexts.unregisteredBody }}</p>
            </div>
          </div>
        </CCardBody>

        <!-- 初期（検索前など） -->
        <CCardBody v-else>
          <div>検索してください。</div>
        </CCardBody>

        <!--
          発行した請求書（その月の、記録1枚が1行）。取り消し済みも、状態つきで同じ表に出す。
          **1枚も無ければ、見出しごと出さない。**更新の表・再作成の表を開いているあいだは出さない
          （入力の途中で、別の操作を混ぜない）。

          ［請求書］は、発行した紙（記録の写しから描く。何度開いても同じ）。
          ［取り消す］は、発行済みの請求書にだけ出す。どちらも「請求書の管理」を持つ人にだけ出す。
          請求書は、記録の番号（invoice_id）で指す。
        -->
        <CCardBody v-if="invoices.length > 0 && mode !== 'edit' && mode !== 'recreate'" class="issued-invoices">
          <h5 class="sales-section-title">{{ invoiceTexts.issuedHeading }}</h5>
          <div class="table-responsive">
            <table class="table table-bordered issued-table">
              <thead>
                <tr>
                  <th>{{ invoiceTexts.issuedColumns.invoiceNo }}</th>
                  <th>{{ invoiceTexts.issuedColumns.issuedOn }}</th>
                  <th>{{ invoiceTexts.issuedColumns.billTo }}</th>
                  <th>{{ invoiceTexts.issuedColumns.unit }}</th>
                  <th class="text-right">{{ invoiceTexts.issuedColumns.amount }}</th>
                  <th>{{ invoiceTexts.issuedColumns.status }}</th>
                  <th v-if="canOutputAndIssueInvoice"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="inv in invoices"
                  :key="inv.invoice_id"
                  :class="{ 'issued-row--voided': inv.status === 'VOID' }"
                >
                  <td>{{ inv.invoice_no }}</td>
                  <td>{{ inv.issued_on ? String(inv.issued_on).replace(/-/g, "/") : "" }}</td>
                  <td class="issued-cell-name">{{ inv.bill_to_name }}</td>
                  <td class="issued-cell-name">{{ invoiceUnitText(inv) }}</td>
                  <td class="text-right">{{ inv.total_amount === null || inv.total_amount === undefined ? "" : formatNum(inv.total_amount) }}</td>
                  <td class="issued-cell-status">
                    <template v-if="inv.status === 'VOID'">
                      <div>{{ invoiceTexts.voided }}</div>
                      <div class="invoice-state">{{ invoiceTexts.voidedDetail(inv.voided_on, inv.voided_by, inv.void_reason) }}</div>
                    </template>
                    <template v-else>{{ invoiceTexts.issued }}</template>
                  </td>
                  <td v-if="canOutputAndIssueInvoice">
                    <div class="invoice-actions">
                      <!-- 受け取るあいだの見せ方は、上の表の［請求書］と同じ作り（同じ印・同じ字）。 -->
                      <button
                        class="btn btn-info btn-sm"
                        :disabled="downloadingInvoice !== ''"
                        :aria-busy="isDownloadingInvoice('issued', inv.invoice_id) ? 'true' : 'false'"
                        @click="openIssuedInvoice(inv)"
                      >
                        <span v-if="isDownloadingInvoice('issued', inv.invoice_id)" class="my-spinner" aria-hidden="true"></span>
                        {{ isDownloadingInvoice('issued', inv.invoice_id) ? invoiceTexts.downloading : '請求書' }}
                      </button>
                      <button
                        v-if="inv.status === 'ISSUED'"
                        class="btn btn-outline-danger btn-sm ml-2"
                        :disabled="voiding"
                        @click="openVoidDialog(inv)"
                      >{{ invoiceTexts.voidButton }}</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCardBody>
      </template>
    </CCard>

    <!--
      発行する前の確かめ（画面の中の小窓）。

      ［発行］［一括発行］は、押しただけでは送らない。ここの進めるボタンで送る。
      **送っているあいだは、2つのボタンを押せなくし、×・背景でも閉じない。**
      閉じると、発行が進んでいるのか止まったのかが分からなくなる
      （×と背景は update:show を出すだけで、閉じるかどうかはこの画面が決める）。

      結果はここには出さない。終わったら小窓を閉じ、成功なら一覧の欄が発行済みに
      変わり、断りなら画面の上に理由が出る（小窓を使う前と同じ）。
    -->
    <CModal
      :show="issueDialog !== null"
      :title="invoiceTexts.issueDialogTitle"
      color="primary"
      :close-on-backdrop="!issuing"
      class="issue-dialog"
      @update:show="closeIssueDialog"
    >
      <!-- 発行する相手の名前（表に出ている名前のまま）。一括のときは出さない。 -->
      <p v-if="issueDialogTargetName" class="issue-dialog__target">{{ issueDialogTargetName }}</p>
      <p class="issue-dialog__body">{{ issueDialogBody }}</p>
      <!--
        発行できたかどうかが分からないとき（通信が切れた・時間切れ・サーバの障害）。
        小窓を閉じずに、ここにそのことを出す。同じ対象・同じ発行の操作の印のまま、
        もう一度［発行する］を押せる（もう発行されていれば、同じ請求書が返る。2枚目はできない）。
      -->
      <div v-if="issueDialogError" class="void-dialog__error issue-dialog__error" role="alert">{{ issueDialogError }}</div>
      <template #footer>
        <CButton color="secondary" :disabled="issuing" @click="closeIssueDialog">
          {{ invoiceTexts.issueDialogCancel }}
        </CButton>
        <CButton color="primary" :disabled="issuing" @click="confirmIssue">
          {{ invoiceTexts.issueDialogProceed }}
        </CButton>
      </template>
    </CModal>

    <!--
      取り消す前の確かめ（画面の中の小窓）。発行の小窓と同じ作り。

      ［取り消す］は、押しただけでは送らない。相手の名前と請求番号を見せ、理由（必須・1行）を
      入れてもらい、ここの進めるボタンで送る。**送っているあいだは、ボタンを押せなくし、
      ×・背景でも閉じない。**結果はここには出さない。終わったら小窓を閉じ、成功なら
      一覧の上に知らせが出て、その請求書が取り消し済みに変わる。断りなら画面の上に理由が出る。
    -->
    <CModal
      :show="voidDialog !== null"
      :title="invoiceTexts.voidDialogTitle"
      color="danger"
      :close-on-backdrop="!voiding"
      class="void-dialog"
      @update:show="closeVoidDialog"
    >
      <p v-if="voidDialog" class="issue-dialog__target">{{ voidDialogTargetName }}</p>
      <p class="issue-dialog__body">{{ invoiceTexts.voidDialogBody }}</p>
      <label class="void-dialog__label" for="sales-void-reason">
        {{ invoiceTexts.voidReasonLabel }}
      </label>
      <input
        id="sales-void-reason"
        v-model="voidReason"
        type="text"
        class="form-control"
        maxlength="500"
        :placeholder="invoiceTexts.voidReasonPlaceholder"
        :disabled="voiding"
        @keyup.enter="confirmVoid"
      />
      <div v-if="voidReasonError" class="void-dialog__error" role="alert">{{ voidReasonError }}</div>
      <template #footer>
        <CButton color="secondary" :disabled="voiding" @click="closeVoidDialog">
          {{ invoiceTexts.issueDialogCancel }}
        </CButton>
        <CButton color="danger" :disabled="voiding" @click="confirmVoid">
          {{ invoiceTexts.voidDialogProceed }}
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ConstList from "../../ConstList";
import { reportDownloadFailure } from '@/utils/downloadFailure';
import { downloadBlobResponse } from '@/utils/fileDownload';
import { safeResponseMessage } from '@/utils/safeResponseMessage';
import { getCachedAccessContext } from '@/services/accessContext';
import { canAccessPath, canEditSalesRecords, canOutputAndIssueSalesInvoice } from '@/utils/accessPolicy';
import { invoiceIssuerLabel } from '@/setting/invoiceIssuerFields';
import {
  invoiceIssuerMissingNotice,
  INVOICE_ISSUER_WHERE_TO_SET,
  INVOICE_ISSUER_ASK_ADMIN,
} from '@/setting/invoiceIssuerTexts';
import invoiceTexts from './salesInvoiceTexts';

/**
 * 数値として扱う項目と、画面に出ている見出し。
 *
 * **押せない理由に出す名前は、この表から取る。**変数名（unit_price）を
 * 出しても、利用者は表のどの列を直せばよいか分からない。
 *
 * 列を足したらここへも足すこと。ここに無い項目は「数字として読めるか」を
 * 誰も見ないので、また黙って 0 で保存される項目が生まれる。
 * 下限・上限は保存の本文には入らないが、控除・超過の自動計算の元になる。
 */
const NUMBER_FIELDS = [
  { key: "base_time_min", label: "下限" },
  { key: "base_time_max", label: "上限" },
  { key: "unit_price", label: "単価" },
  { key: "unit_price_deduct", label: "控除" },
  { key: "unit_price_excess", label: "超過" },
  { key: "settlement_time", label: "精算（H）" },
  { key: "amount_sales", label: "売上（円）" },
  { key: "amount_cost", label: "原価" },
];

/** その他経費の数値項目。見出しは入力欄のプレースホルダと同じ言葉。 */
const EXPENSE_NUMBER_FIELDS = [
  { key: "qty", label: "数量" },
  { key: "unit_price", label: "単価" },
  { key: "amount", label: "金額" },
];

export default {
  name: "SalesManagement",

  data() {
    return {
      year: "",
      month: "",
      yearOption: [],
      monthOption: [],

      callFlg: false,
      showYearMonth: false,
      selectYear: "",
      selectMonth: "",

      mode: "", // '' | 'new' | 'view' | 'edit' | 'recreate'（最新を取り込んで作り直した表） | 'unregistered'（未登録の月を、登録できない人が開いた）
      rows: [],
      viewRows: [],
      formRows: [],

      errors: [],
      saving: false,

      /* 発行の口へ送っているあいだ。二度押しで同じ発行を2回送らない。 */
      issuing: false,
      /*
       * 発行する前の確かめの小窓。null は閉じている。
       * 開いているときは { all（一括か）, targets（送る対象）, targetName（相手の名前） }。
       */
      issueDialog: null,
      /* 発行の小窓の中に出す、結果が分からなかったことの1行。空は、出さない。 */
      issueDialogError: "",
      /*
       * 請求書のファイル（PDF・ZIP）を受け取っているあいだ、どのボタンを押したか。空は受け取っていない。
       * 「company:3」「project:7」「user:11:3」「zip」。押したボタンを処理中の見た目にし、
       * 受け取り終わるまで、ほかの［請求書］［一括ダウンロード］も押せなくする。
       */
      downloadingInvoice: "",
      /* 請求書に載せる自社の情報で、まだ空の項目の鍵（サーバが返す）。 */
      issuerMissing: [],
      /*
       * ［最新を取り込んで再作成］を押したが、作り直す分が1つも無かった（ボタンの横に、そのことを出す）。
       * 検索し直す・もう一度押すと消える。
       */
      recreateNothing: false,
      /*
       * 再作成の表で差し替える行の番号（表を取ったときにサーバが返した replace_ids）。［登録］で一緒に送り、
       * サーバはこの番号の行だけを消す（表を開いたあとで取り消して未発行に戻った明細は消さない。監査 RC-1）。
       */
      recreateReplaceIds: [],
      /* 差し替える行のうち、作り直した表に無い明細（当月除外など）。［登録］で消えるので、表の上に出す（監査 RC-2）。 */
      recreateRemoved: [],
      /* 表示している月の、発行した請求書（取り消し済みも含む。サーバが返したまま持つ）。 */
      invoices: [],
      /*
       * 取り消す前の確かめの小窓。null は閉じている。開いているときは、取り消す請求書
       * （一覧の1行。invoice_id・invoice_no・bill_to_name）。
       */
      voidDialog: null,
      voidReason: "",
      voidReasonError: "",
      /* 取り消しの口へ送っているあいだ。二度押しで同じ取り消しを2回送らない。 */
      voiding: false,
      /* 済んだことの知らせ（取り消したあと・再作成で入れ替えなかった明細があったとき）。検索し直すと消える。 */
      notice: "",
      projectRatePath: "/admin/project-rate",
      /*
       * 権限と契約。画面へ入るときに経路の守りが読み込んだもの。
       * 無ければ、請求書の出力と発行も、売上の行の登録・更新・作り直しも出さない。
       */
      accessContext: null,
      invoiceTexts: invoiceTexts,
      issuerTexts: {
        whereToSet: INVOICE_ISSUER_WHERE_TO_SET,
        askAdmin: INVOICE_ISSUER_ASK_ADMIN,
      },
    };
  },

  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.accessContext = getCachedAccessContext();
  },

  mounted() {
    if (Object.prototype.hasOwnProperty.call(sessionStorage, "sales-search-params")) {
      const params = JSON.parse(sessionStorage.getItem("sales-search-params"));
      this.year = params.year;
      this.month = params.month;
      this.callList();
      return;
    }

    let today = moment();
    if (today.date() < 10) {
      today = today.subtract(1, "months");
    }
    this.year = today.format("YYYY");
    this.month = today.format("M");
    /*
     * **開いたら、その月で検索する。**以前は、初めて開いたときは年月を入れるだけで、
     * ［検索］を押すまで何も出なかった（毎月の最初の1手が、押す必要の無い1手だった）。
     */
    this.callList();
  },

  methods: {
    /**
     * 断られた理由を、利用者が次に何をすればよい形で出す。
     *
     * 400番台でサーバが返す message は「既に対象月の売上が登録されています。」
     * のような**復旧手順そのもの**で、これを捨てて「システムエラーです。
     * 管理者に問い合わせてください。」に置き換えると行き止まりになる。
     * **この画面を使っているのが管理者本人なので、問い合わせ先がいない。**
     *
     * 障害ログ（/error/frontError）へ積むのは 5xx と通信断だけ。入力の不備を
     * 積むと本当の障害が埋もれる。
     */
    /*
     * isCurrent：その要求を出した画面（表示の世代）がいまも同じか。**画面に何かを出す直前に必ず確かめる**
     * （設計書 14章 R7。監査 RC-6）。障害の案内は記録を送ったあとで出すので、そのあいだに別の月を
     * 検索していたら、記録は送るが案内は出さない。渡さない呼び出しは、今までどおりいつも出す。
     */
    /*
     * 表示の世代（設計書 14章 R7）。**画面に結果を書く要求は、始めるときにこの関数を作り、結果を書く直前に呼ぶ。**
     * 検索し直すと世代が進むので、前の画面で始めた要求の結果（一覧・表・知らせ・断り・障害の案内）は、
     * いまの画面に書かない。保存のあとの一覧の読み直しも検索なので、自分で世代を進め、その読み直しが
     * 始めた初期データの取得まで同じ世代で確かめる（監査 RE-1）。
     */
    currentGeneration: function () {
      const generation = this.$_listGeneration || 0;
      return () => generation === (this.$_listGeneration || 0);
    },

    /** 検索し直す（新しい画面にする）。世代を1つ進め、その世代のままかを答える関数を返す。 */
    startListGeneration: function () {
      this.$_listGeneration = (this.$_listGeneration || 0) + 1;
      return this.currentGeneration();
    },

    handleRequestFailure: function (error, isCurrent) {
      const shown = typeof isCurrent === "function" ? isCurrent : () => true;
      const status = error && error.response ? Number(error.response.status) : 0;

      if (status >= 400 && status < 500) {
        if (!shown()) return;
        this.errors = [safeResponseMessage(error, ConstList.SYSTEM_ERROR)];
        this.scrollToErrors();
        return;
      }

      axios
        .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error && error.message ? error.message : String(error) }, { headers: { 'Content-Type': 'application/json' } })
        .then(() => { if (shown()) alert(ConstList.SYSTEM_ERROR); })
        .catch(() => { if (shown()) alert(ConstList.SYSTEM_COMMUNICATION_ERROR); });
    },

    /** サーバが答えた業務上の断り（4xx）か。通信が切れた・時間切れ・5xx は、結果が分からない失敗。 */
    isRefusal: function (error) {
      const status = error && error.response ? Number(error.response.status) : 0;
      return status >= 400 && status < 500;
    },

    /**
     * 理由は画面の一番上に出る。長い表を触っている最中に失敗すると、
     * **その場では何も変わらないように見える。**
     */
    scrollToErrors: function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    callList: function () {
      this.errors = [];
      this.callFlg = false;
      this.showYearMonth = true;
      this.selectYear = this.year;
      this.selectMonth = this.month;

      this.mode = "";
      this.rows = [];
      this.viewRows = [];
      this.formRows = [];
      this.issuerMissing = [];
      this.recreateNothing = false;
      this.recreateReplaceIds = [];
      this.recreateRemoved = [];
      this.invoices = [];
      this.notice = "";
      /*
       * 表示の世代。検索のたびに1つ進める。この検索の一覧・初期データ・断り・障害の案内も、ほかの要求と
       * 同じく、始めたときの世代と違えば画面に何もしない（9月の結果を10月の画面へ出さない。月の文字だけでは
       * 9月→10月→9月と戻ったときを見分けられない。監査 RC-3・RE-1）。画面に出さない数なので data に置かない。
       */
      const isCurrent = this.startListGeneration();

      /*
       * **応答の中身は、検索した月（見出しの月）のものだけを使う。**
       *
       * 初期データを「応答が返った時点の選択欄の月」で取っていたので、待つあいだに
       * 選択欄を変えると、見出しは9月のまま10月の中身が並び、［登録］が10月の中身を
       * 9月の売上として確定していた。初期データも検索した月で取る。
       * 検索し直して見出しの月が変わったあとに届いた前の検索の応答は捨てる。
       */
      const year = this.year;
      const month = this.month;

      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/list", {
          params: { year: year, month: month },
        })
        .then((res) => {
          if (!isCurrent() || !this.isShownMonth(year, month)) return;
          const exists = !!res.data.exists;

          if (!exists) {
            // 売上の行が無い月でも、取り消した請求書の記録はある（取り消して作り直した月）。
            this.invoices = Array.isArray(res.data.invoices) ? res.data.invoices : [];
            this.callFlg = true;
            sessionStorage.setItem("sales-search-params", JSON.stringify({ year: year, month: month }));
            /*
             * **登録できない人には、新規登録の表を出さない。**
             *
             * 売上の行を書く口（登録・更新・作り直し）は、「売上情報の管理」を持つ人しか
             * 通らない（サーバの決まり）。「請求書の管理」だけの人に新規登録の表を出すと、
             * 全部入れて［登録］を押したところで必ず断られる。その月がまだ登録されて
             * いないことだけを出す（初期データも取りに行かない）。
             */
            if (!this.canEditSales) {
              this.mode = "unregistered";
              return;
            }
            this.mode = "new";
            this.loadInitRows(year, month, isCurrent);
            return;
          }

          // 登録済：参照表示（DB保存値をそのまま表示する想定）
          this.showRegisteredRows(res.data);
          this.mode = "view";
          this.callFlg = true;

          sessionStorage.setItem("sales-search-params", JSON.stringify({ year: year, month: month }));
        })
        .catch((error) => this.handleRequestFailure(error, isCurrent));
    },

    /**
     * 登録済みの月の応答（/sales/list）を、参照表示の行にする。
     *
     * 検索したとき（callList）と、発行したあとの読み直し（refreshRegisteredRows）の
     * 両方がここを通る。請求番号・発行日・自社の情報で空の項目は、サーバが返した
     * ものをそのまま持つ（画面で作らない）。
     */
    showRegisteredRows: function (data) {
      this.rows = ((data && data.items) || []).map((r) => {
        const row = { ...r };
        row.is_invoiced = (row.is_invoiced === true);
        row.due_date = row.due_date || "";
        row.project_name = row.project_name || "";
        row.staff_name = row.staff_name || row.user_name || "";
        row.other_expenses = this.normalizeOtherExpenses(row.other_expenses);
        // 載っている請求書（あれば）。空は「まだ請求書に載っていない」。null にそろえる。
        row.invoice_id = row.invoice_id || null;
        row.invoice_no = row.invoice_no || "";
        row._manual = { deduct: false, excess: false, sales: false };
        return row;
      });

      this.viewRows = this.buildRowspan(this.unissuedRows(this.rows));
      this.issuerMissing = Array.isArray(data && data.issuer_missing) ? data.issuer_missing : [];
      this.invoices = Array.isArray(data && data.invoices) ? data.invoices : [];
    },

    /**
     * 上の表（まだ発行していない分）に出す行。「発行」が入で、まだ請求書に載っていない行。
     * 表・一括発行・小窓が送る行は、どれもここから取る（別々に絞らない）。
     */
    unissuedRows: function (rows) {
      return (rows || []).filter((r) => r.is_invoiced === true && !r.invoice_id);
    },

    /** 更新の表で、その行が発行した請求書に載っているか（載っていれば、紙に出る項目は入力できない）。 */
    isOnInvoice: function (r) {
      return !!(r && r.invoice_id);
    },

    /**
     * その会社の行が、全部、請求書に載っているか。支払期限は会社でまとめた1つの欄なので、
     * **全部が発行済みのときだけ**入力できない。未発行の行が1つでもあれば入力できる
     * （同じ会社の請求書を一部だけ取り消して、その分の支払期限を直せるように）。
     */
    companyAllOnInvoice: function (companyId) {
      return !this.formRows.some((r) => r.company_id === companyId && !r.invoice_id);
    },

    /** 更新の表の、支払期限の欄（会社でまとめた1つ）を止めるか。その会社の行が全部、請求書に載っているときだけ。 */
    dueDateLocked: function (r) {
      return this.companyAllOnInvoice(r.company_id);
    },

    /** 更新の表の、プロジェクト名の欄（プロジェクトでまとめた1つ）を止めるか。 */
    projectNameLocked: function (r) {
      return this.projectAllOnInvoice(r.project_id);
    },

    /** そのプロジェクトの行が、全部、請求書に載っているか（プロジェクト名はプロジェクトでまとめた1つの欄）。 */
    projectAllOnInvoice: function (projectId) {
      return !this.formRows.some((r) => r.project_id === projectId && !r.invoice_id);
    },

    /**
     * 再作成の表で、その行が「入れ直さない行」か（発行した請求書に載っている行）。
     * 再作成は、載っている行を何も変えないので、更新では直せる物（その他経費の備考）も止める。
     */
    recreateKeepsRow: function (r) {
      return this.mode === "recreate" && this.isOnInvoice(r);
    },

    /**
     * 再作成の表で、会社の備考の欄（会社でまとめた1つ）を止めるか。その会社に、発行した請求書に
     * 載っている行が1つでもあるとき。備考は前のまま引き継いである。直すのは［更新］で。
     */
    recreateKeepsCompanyRemarks: function (r) {
      return this.mode === "recreate" &&
        this.formRows.some((row) => row.company_id === r.company_id && !!row.invoice_id);
    },

    /**
     * 会社の支払期限の欄が読み書きする行。その会社の、未発行の行の最初の1つ
     * （発行済みと未発行で値が違うとき、欄に出すのは未発行の値）。全部が発行済みなら、欄を出している行。
     */
    dueDateRow: function (r) {
      return this.formRows.find((row) => row.company_id === r.company_id && !row.invoice_id) || r;
    },

    /** プロジェクト名の欄が読み書きする行。そのプロジェクトの、未発行の行の最初の1つ。 */
    projectNameRow: function (r) {
      return this.formRows.find((row) => row.project_id === r.project_id && !row.invoice_id) || r;
    },

    /**
     * 発行したあと、表示している月を読み直す。
     *
     * **検索（callList）は使わない。**あちらは表をいったん消して作り直すので、
     * 長い表の下のほうで発行すると、押した場所を見失う。ここは表を出したまま、
     * 行だけを入れ替える。番号と発行日は、サーバが保存したものを読み直して出す
     * （画面で組み立てない）。
     */
    refreshRegisteredRows: function () {
      const year = this.selectYear;
      const month = this.selectMonth;
      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/list", {
          params: { year: year, month: month },
        })
        .then((res) => {
          if (!this.isShownMonth(year, month)) return;
          if (this.mode !== "view") return;
          if (!res.data.exists) {
            // 読み直したら登録が無くなっていた（別の人が作り直した）。検索からやり直す。
            this.useShownMonth();
            this.callList();
            return;
          }
          this.showRegisteredRows(res.data);
        });
    },

    /**
     * 請求書を発行する（会社・プロジェクト・スタッフのどれか1つ）。
     *
     * **押しただけでは送らない。**確かめの小窓を開き、小窓の進めるボタンで送る
     * （confirmIssue）。小窓は画面の中の小窓（CModal）。ブラウザ標準の小窓
     * （window.confirm）は使わない。見た目がアプリと合わず、画面を本物の操作で
     * 確かめるときにそこで止まる（2026-10-09）。
     *
     * **請求書のPDFは、ここでは開かない。**発行は番号と発行日を決める操作、
     * ［請求書］は紙を受け取る操作、と分けてある。
     */
    issueInvoice: function (scope, id, companyId) {
      if (this.issuing) return;
      const target = { scope: scope };
      if (scope === "company") target.company_id = id;
      if (scope === "project") target.project_id = id;
      if (scope === "user") {
        if (!companyId) {
          alert("請求先の会社を特定できませんでした。再検索してください。");
          return;
        }
        target.user_id = id;
        target.company_id = companyId;
      }
      /*
       * **小窓を開いたときに、その欄のまだ発行していない行と、発行の操作の印を持つ。**
       * 発行されるのは、ここで持った行だけ（小窓を開いたあとで別の人が足した行は載らない）。
       * 印は、同じ操作の送り直し（通信が切れた など）で2枚目を作らないためのもの。
       * 小窓を開き直せば、新しい印になる。
       */
      target.sales_ids = this.unitSalesIds(scope, id, companyId);
      target.request_id = this.newIssueRequestId();
      this.issueDialogError = "";
      this.issueDialog = {
        all: false,
        targets: [target],
        targetName: this.issueTargetName(scope, id, companyId),
      };
    },

    /** その欄（会社・プロジェクト・スタッフ）の、まだ発行していない行の番号。表に出ている行から取る。 */
    unitSalesIds: function (scope, id, companyId) {
      return this.viewRows
        .filter((r) => {
          if (scope === "company") return r.company_id === id;
          if (scope === "project") return r.project_id === id;
          return r.user_id === id && r.company_id === companyId;
        })
        .map((r) => r.id);
    },

    /** 発行の操作の印（乱数の文字列。32桁の16進）。ブラウザの乱数で作る。 */
    newIssueRequestId: function () {
      const bytes = new Uint8Array(16);
      const source = (typeof window !== "undefined" && (window.crypto || window.msCrypto)) || null;
      if (source && source.getRandomValues) {
        source.getRandomValues(bytes);
      } else {
        for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
      }
      return Array.prototype.map.call(bytes, (b) => ("0" + b.toString(16)).slice(-2)).join("");
    },

    /**
     * 未発行の会社の請求書を、まとめて発行する。発行済みの会社は送らない。
     * こちらも、押したら確かめの小窓を開くだけ。送るのは小窓の進めるボタン。
     */
    issueAllCompanyInvoices: function () {
      if (this.issuing) return;
      const companyIds = this.unissuedCompanyIds;
      if (companyIds.length === 0) return;
      // 欄（会社）ごとに、確かめた行と、発行の操作の印を1つずつ持つ。
      this.issueDialogError = "";
      this.issueDialog = {
        all: true,
        targets: companyIds.map((id) => ({
          scope: "company",
          company_id: id,
          sales_ids: this.unitSalesIds("company", id),
          request_id: this.newIssueRequestId(),
        })),
        targetName: "",
      };
    },

    /**
     * 小窓に出す、発行する相手の名前（表に出ている名前のまま）。
     * 会社・プロジェクト・スタッフの3つの［発行］が同じ文の小窓を開くので、
     * どれを押したのかを小窓の中でもう一度見せる。スタッフは「名前（会社名）」。
     */
    issueTargetName: function (scope, id, companyId) {
      const row = this.viewRows.find((r) => {
        if (scope === "company") return r.company_id === id;
        if (scope === "project") return r.project_id === id;
        return r.user_id === id && r.company_id === companyId;
      });
      if (!row) return "";
      if (scope === "company") return row.company_name || "";
      if (scope === "project") return row.project_name || "";
      return `${row.staff_name || row.user_name || ""}（${row.company_name || ""}）`;
    },

    /**
     * 小窓を閉じる（［キャンセル］・×・背景）。何も送らない。
     * **送っているあいだは閉じない。**閉じると、発行が進んでいるのか分からなくなる。
     */
    closeIssueDialog: function () {
      if (this.issuing) return;
      this.issueDialog = null;
      this.issueDialogError = "";
    },

    /** 小窓の進めるボタン。開いている小窓の対象を、発行の口へ送る。 */
    confirmIssue: function () {
      if (this.issuing || this.issueDialog === null) return;
      this.postIssue(this.issueDialog.targets);
    },

    /**
     * 発行の口へ送る。表示している行の請求書なので、見出しの月で送る
     * （選択欄の月ではない）。
     *
     * 小窓は、送って一覧を読み直し終わるまで（か、断られるまで）開いたままにし、
     * そのあいだボタンは押せない。終わったら閉じる。結果は今までどおり、
     * 成功なら一覧の欄が発行済みに変わり、断りなら画面の上に理由が出る。
     */
    postIssue: function (targets) {
      this.issuing = true;
      this.errors = [];
      this.issueDialogError = "";
      // 結果が分からない失敗のときだけ、小窓を開いたままにする（下の catch）。
      let keepDialog = false;
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/invoice/issue", {
          year: this.selectYear,
          month: this.selectMonth,
          targets: targets,
        })
        .then((res) => {
          /*
           * 発行されなかった欄があるとき（小窓を開いたあとで、別の人がその明細を発行した・
           * 変えた）。一覧を読み直したうえで、そのことと、次に押すものを上に出す。
           */
          const issued = (res && res.data && res.data.issued) || [];
          const skipped = issued.some((one) => one && one.needs_reload === true);
          return this.refreshRegisteredRows().then(() => {
            if (skipped) {
              this.errors = [this.invoiceTexts.issueNeedsReload];
              this.scrollToErrors();
            }
          });
        })
        /*
         * 世代は渡さない：送ってから読み直し終わるまで小窓が開いたまま（背景でも閉じない）なので、
         * そのあいだに別の月を検索することはできない（設計書 14.9）。
         */
        .catch((error) => {
          // 業務上の断り（4xx）。理由を画面の上に出して、小窓は閉じる（今までどおり）。
          if (this.isRefusal(error)) return this.handleRequestFailure(error);
          /*
           * **発行できたかどうかが分からない**（通信が切れた・時間切れ・5xx）。発行は確定していて、
           * 返事だけが届かなかったのかもしれない。小窓を閉じると、対象の行と発行の操作の印を
           * 捨ててしまい、押し直しが「別の発行」になる。閉じずに、同じ対象・同じ印のまま
           * もう一度押せるようにする。障害の記録は残す（案内の小窓は出さない）。
           */
          keepDialog = true;
          this.issueDialogError = this.invoiceTexts.issueResultUnknown;
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error && error.message ? error.message : String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .catch(() => {});
        })
        .finally(() => {
          this.issuing = false;
          if (!keepDialog) {
            this.issueDialog = null;
          }
        });
    },

    /** 下の表の「単位」の欄。会社の単位は名前があて先と同じなので、単位の名前だけ。 */
    invoiceUnitText: function (inv) {
      const label = this.invoiceTexts.scopeLabels[inv.scope] || "";
      return inv.unit_name ? `${label}：${inv.unit_name}` : label;
    },

    /** ［取り消す］を押した。確かめの小窓を開くだけ（送るのは小窓の進めるボタン）。 */
    openVoidDialog: function (inv) {
      if (this.voiding) return;
      this.voidReason = "";
      this.voidReasonError = "";
      this.voidDialog = inv;
    },

    /** 小窓を閉じる（［キャンセル］・×・背景）。何も送らない。送っているあいだは閉じない。 */
    closeVoidDialog: function () {
      if (this.voiding) return;
      this.voidDialog = null;
      this.voidReasonError = "";
    },

    /**
     * 小窓の進めるボタン。理由が空なら、送らずに欄の下に断りを出す。
     * 入っていれば、取り消しの口へ送り、一覧を読み直してから小窓を閉じる。
     */
    confirmVoid: function () {
      if (this.voiding || this.voidDialog === null) return;
      const reason = String(this.voidReason || "").trim();
      if (reason === "") {
        this.voidReasonError = this.invoiceTexts.voidReasonRequired;
        return;
      }
      this.voidReasonError = "";
      this.voiding = true;
      this.errors = [];
      this.notice = "";
      /*
       * 押したときの表示の世代。送ってから読み直し終わるまでは小窓が開いたままで検索できないが、障害（500・通信断）の
       * ときの記録の送信は小窓が閉じたあとも残るので、その案内は始めた世代でだけ出す（R7・監査 RE-2）。
       */
      const isCurrent = this.currentGeneration();
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/invoice/void", {
          invoice_id: this.voidDialog.invoice_id,
          reason: reason,
        })
        .then((res) => {
          /*
           * 取り消したあとも、その請求書の明細が別の発行済みの請求書に載っていることがある
           * （サーバが、その請求番号を返す）。その明細はまだ直せないので、
           * 「修正して再発行できます」ではなく、もう1枚の取り消しが要ることを言う。
           */
          const stillOn = (res && res.data && Array.isArray(res.data.still_on_invoices))
            ? res.data.still_on_invoices : [];
          return this.reloadShownMonth().then(() => {
            this.notice = stillOn.length > 0
              ? this.invoiceTexts.voidDoneStillOnInvoices(stillOn)
              : this.invoiceTexts.voidDone;
          });
        })
        .catch((error) => {
          // 断り（4xx）はすぐ出る。障害の案内は記録を送ったあとなので、始めた世代を渡す（監査 RE-2）。
          this.handleRequestFailure(error, isCurrent);
          // 断られたとき（もう取り消されている など）も、いまの状態を読み直して見せる。
          return this.reloadShownMonth().catch(() => {});
        })
        .finally(() => {
          this.voiding = false;
          this.voidDialog = null;
        });
    },

    /**
     * 表示している月を読み直す（表は出したまま）。登録が無い月（売上の行が無く、取り消した
     * 請求書だけがある月）では、請求書の一覧だけを入れ替える。
     */
    reloadShownMonth: function () {
      if (this.mode === "view") return this.refreshRegisteredRows();
      const year = this.selectYear;
      const month = this.selectMonth;
      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/list", {
          params: { year: year, month: month },
        })
        .then((res) => {
          if (!this.isShownMonth(year, month)) return;
          this.invoices = Array.isArray(res.data.invoices) ? res.data.invoices : [];
        });
    },

    // 見出しに出している月（最後に検索した月）が、この年月か。
    isShownMonth: function (year, month) {
      return String(this.selectYear) === String(year) && String(this.selectMonth) === String(month);
    },

    /*
     * 新規の初期データ。検索した月（見出しの月）と、その検索の世代（isCurrent）を受け取って頼む。
     * 届いたときに世代が違えば（検索し直した・新しい表を開いた）、表を書き換えない（監査 RE-1）。
     */
    loadInitRows: function (year, month, isCurrent) {
      const shown = typeof isCurrent === "function" ? isCurrent : this.currentGeneration();
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/init", {
          params: { year: year, month: month },
        })
        .then((res) => {
          if (!shown() || !this.isShownMonth(year, month)) return;
          const items = res.data.items || [];
          this.formRows = this.buildFormCompanyRowspan(items.map((r) => this.latestFormRow(r)));

          // 初期自動計算
          this.formRows.forEach((r) => {
            this.autoCalcDeductExcess(r);
            this.autoCalcSales(r);
          });
        })
        .catch((error) => this.handleRequestFailure(error, shown));
    },

    /**
     * 最新の実績・金額設定から作った行（サーバが返す。まだ保存していない）を、入力の表の行にする。
     * 新規の表（loadInitRows）と、再作成の表（recreateLatest）の作り直した行が、どちらもここを通る。
     */
    latestFormRow: function (r) {
      const row = { ...r };
      /*
       * 金額設定が1件も無い人は、サーバが単価・原価を null で返す。
       * 0 に置き換えると単価0・原価0 のまま登録（確定）でき、集計の
       * 「金額未設定」の警告も消える（2026-09-30）。空欄で見せて印を付け、
       * rateUnsetMembers で止める。原価はこの画面に欄が無いので、単価を
       * 打っても印は外さない（直す先はプロジェクト金額設定）。
       */
      row._rateUnset = (row.unit_price === null || row.unit_price === undefined ||
        row.amount_cost === null || row.amount_cost === undefined);
      row.unit_price = (row.unit_price ?? "");
      row.amount_cost = (row.amount_cost ?? 0);
      row.settlement_time = (row.settlement_time ?? 0);
      row.unit_price_deduct = (row.unit_price_deduct ?? 0);
      row.unit_price_excess = (row.unit_price_excess ?? 0);
      row.amount_sales = (row.amount_sales ?? 0);
      row.remarks = (row.remarks ?? "");
      /*
       * 「発行」は、サーバが返したまま。新規の表では、サーバがいつも入で返す。
       * 再作成の表では、前の行で切にしてあれば、切で返ってくる（引き継ぎはサーバがする）。
       */
      row.is_invoiced = (row.is_invoiced !== false);
      row.due_date = row.due_date || "";
      row.project_name = row.project_name || "";
      row.staff_name = row.staff_name || row.user_name || "";
      row.other_expenses = this.normalizeOtherExpenses(row.other_expenses);
      row._manual = { deduct: false, excess: false, sales: false };
      return row;
    },

    /** 保存してある行（一覧が返した行）を、入力の表の行にする。更新の表と、再作成の表の変えられない行。 */
    storedFormRow: function (r) {
      const row = { ...r };
      row.is_invoiced = (row.is_invoiced === true);
      row.due_date = row.due_date || "";
      row.project_name = row.project_name || "";
      row.staff_name = row.staff_name || row.user_name || "";
      row.other_expenses = this.normalizeOtherExpenses(row.other_expenses);
      row._manual = { deduct: false, excess: false, sales: false };
      return row;
    },
    /*
     * **登録・更新・作り直しは、見出しに出している月（検索した月）で送る。**
     *
     * 年月の選択欄を送っていたので、検索のあと選択欄だけ変えて押すと、見えている行を
     * 別の月へ登録し、別の月の請求データを作り直し（消し）ていた。選択欄も
     * 表示中の月へ戻す（送る年月と、押したあとの読み直しが使う）。
     */
    useShownMonth: function () {
      this.year = this.selectYear;
      this.month = this.selectMonth;
    },
    /**
     * ［最新を取り込んで再作成］。**押しただけでは、何も消えない・何も入れ替わらない。**
     *
     * サーバから、作り直した表をもらって見せる。発行した請求書に載っている行は、いまの値のままの
     * 変えられない行。それ以外は、最新の実績・金額設定で作り直した行で、「発行」の入切と、
     * 手で入れるしかない物（項目補足・精算・その他経費・備考）は、サーバが前の行から引き継いで
     * 返す（ブラウザに控えを置かない。別の人・別の端末で押しても同じ表になる）。
     * 控除・超過・売上は、新規の表と同じく、この画面が自動で計算する。
     *
     * 入れ替わるのは、表を見て［登録］を押したとき（saveRecreate）。
     * 確かめの小窓は出さない（ここでは何も失われないので、確かめることが無い）。
     */
    recreateLatest: function () {
      if (this.saving) return;
      // 作り直しは売上の行を書き直す操作。登録・更新できない人は始めない（ボタンも出していない）。
      if (!this.canEditSales) return;

      this.saving = true;
      this.errors = [];
      this.notice = "";
      this.recreateNothing = false;
      // 表示している月を作り直す（選択欄の月ではない）。
      const year = this.selectYear;
      const month = this.selectMonth;
      const isCurrent = this.currentGeneration();

      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/recreate", {
          params: { year: year, month: month },
        })
        .then((res) => {
          if (!isCurrent() || !this.isShownMonth(year, month)) return;
          const items = (res.data && res.data.items) || [];
          const replaceIds = Array.isArray(res.data && res.data.replace_ids) ? res.data.replace_ids : [];
          const removed = Array.isArray(res.data && res.data.removed) ? res.data.removed : [];
          const rows = items.map((r) => (r.invoice_id ? this.storedFormRow(r) : this.latestFormRow(r)));
          /*
           * 作り直す分が1つも無く、差し替える未発行の明細も無い（全部が発行済みで、最新に増えた分も無い）。
           * 変えられない行だけの表を開いても、押せるものが無い。開かずに、ボタンの横にそのことを出す。
           * 差し替える明細があれば（全部を当月除外にした など）、作り直す行が0件でも開く。［登録］で
           * その明細を取り除く（監査 RC-2）。
           */
          if (!rows.some((r) => !r.invoice_id) && replaceIds.length === 0) {
            this.recreateNothing = true;
            return;
          }
          this.recreateReplaceIds = replaceIds;
          this.recreateRemoved = removed;
          this.formRows = this.buildFormCompanyRowspan(rows);
          // 作り直した行だけ、自動計算（載っている行の値には触らない）。
          this.formRows.forEach((r) => {
            if (r.invoice_id) return;
            this.autoCalcDeductExcess(r);
            this.autoCalcSales(r);
          });
          this.mode = "recreate";
        })
        // 検索し直したあとに届いた前の月の断り・障害の案内は、いまの月の画面へ出さない（R7）。
        .catch((error) => this.handleRequestFailure(error, isCurrent))
        .finally(() => {
          this.saving = false;
        });
    },

    /**
     * 再作成の表の［登録］。ここで初めて入れ替わる（サーバが、消すのと入れるのを1回でする）。
     *
     * 送るのは、作り直した行だけ（発行した請求書に載っている行は送らない。サーバも入れ直さない）。
     * 表を見ているあいだに別の人が発行した分は、サーバが入れ直さずに件数を返すので、
     * 一覧を読み直したうえで、そのことを上に出す（全体を断って最初からやり直させない）。
     */
    saveRecreate: function () {
      if (this.saving) return;
      if (this.blockedByMissingFields()) return;
      this.saving = true;
      this.useShownMonth();
      // 押したときの表示の世代。応答が届いたとき、別の月を検索し直していたら画面に何もしない（監査 RC-3）。
      const isCurrent = this.currentGeneration();

      const items = this.normalizeCompanyFields(this.formRows)
        .filter((r) => !r.invoice_id)
        .map((r) => this.registerItem(r));

      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/recreate", {
          year: this.year,
          month: this.month,
          items: items,
          // 表を取ったときに差し替えると決めた行。サーバはこの行だけを消す（監査 RC-1）。
          replace_ids: this.recreateReplaceIds.slice(),
        })
        .then((res) => {
          if (!isCurrent()) return;
          const skipped = Number(res && res.data && res.data.skipped_on_invoice) || 0;
          alert(ConstList.REGISTER_MESSAGE);
          /*
           * 保存を映す読み直しは検索なので、世代を進める（callList）。その一覧・初期データ・断り・障害の案内は、
           * 読み直しが始めた世代で確かめる（あとで別の月を検索したり、新しい表を開いたりしたら書かない。監査 RE-1）。
           * 知らせ（入れなかった件数）は、callList が知らせを消したすぐあとに、同じ処理の中で入れる。
           */
          this.callList();
          if (skipped > 0) {
            this.notice = this.invoiceTexts.recreateSkipped(skipped);
          }
        })
        // 別の月へ移ったあとに届いた断り・障害の案内は、いまの月の画面へ出さない（登録の結果は、その月を開けば分かる。R7）。
        .catch((error) => this.handleRequestFailure(error, isCurrent))
        .finally(() => {
          this.saving = false;
        });
    },

    /** 更新の表・再作成の表の、下の進めるボタン（表は同じで、送り先が違う）。 */
    saveForm: function () {
      if (this.mode === "recreate") return this.saveRecreate();
      return this.saveEdit();
    },

    startEdit: function () {
      // 更新の表への入口。登録・更新できない人は入れない（ボタンも出していない）。
      if (!this.canEditSales) return;
      this.mode = "edit";
      this.recreateNothing = false;
      this.formRows = this.buildFormCompanyRowspan(this.rows.map((r) => this.storedFormRow(r)));
    },

    cancelEdit: function () {
      this.mode = "view";
      this.recreateReplaceIds = [];
      this.recreateRemoved = [];
      this.viewRows = this.buildRowspan(this.unissuedRows(this.rows));
    },

    cancelToNone: function () {
      this.mode = "";
    },

    saveNew: function () {
      if (this.saving) return;
      if (this.blockedByMissingFields()) return;
      this.saving = true;
      this.useShownMonth();
      // 押したときの表示の世代。届いたときに別の月を検索し直していたら、小窓も読み直しもしない（R7）。
      const isCurrent = this.currentGeneration();

      const normalizedRows = this.normalizeCompanyFields(this.formRows);

      const items = normalizedRows.map((r) => this.registerItem(r));

      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/register", {
          year: this.year,
          month: this.month,
          items: items,
        })
        .then(() => {
          if (!isCurrent()) return;
          alert(ConstList.REGISTER_MESSAGE);
          this.callList();
        })
        .catch((error) => this.handleRequestFailure(error, isCurrent))
        .finally(() => {
          this.saving = false;
        });
    },

    /** 新しく入れる行を、サーバへ送る形にする。新規の［登録］と、再作成の［登録］が同じ形で送る。 */
    registerItem: function (r) {
      return {
        user_id: r.user_id,
        project_id: r.project_id,
        project_name: r.project_name || "",
        due_date: r.due_date || null,
        staff_name: r.staff_name || "",
        unit_price: this.readNumber(r.unit_price),
        settlement_time: this.readNumber(r.settlement_time),
        unit_price_deduct: this.readNumber(r.unit_price_deduct),
        unit_price_excess: this.readNumber(r.unit_price_excess),
        amount_sales: this.readNumber(r.amount_sales),
        amount_cost: this.readNumber(r.amount_cost),
        remarks: r.remarks || "",
        is_invoiced: r.is_invoiced === true,
        other_expenses: this.buildOtherExpensePayload(r),
      };
    },

    saveEdit: function () {
      if (this.saving) return;
      if (this.blockedByMissingFields()) return;
      this.saving = true;
      this.useShownMonth();
      // 押したときの表示の世代。届いたときに別の月を検索し直していたら、小窓も読み直しもしない（R7）。
      const isCurrent = this.currentGeneration();

      const normalizedRows = this.normalizeCompanyFields(this.formRows);

      const items = normalizedRows.map((r) => ({
        id: r.id,
        due_date: r.due_date || null,
        project_name: r.project_name || "",
        staff_name: r.staff_name || "",
        unit_price: this.readNumber(r.unit_price),
        settlement_time: this.readNumber(r.settlement_time),
        unit_price_deduct: this.readNumber(r.unit_price_deduct),
        unit_price_excess: this.readNumber(r.unit_price_excess),
        amount_sales: this.readNumber(r.amount_sales),
        amount_cost: this.readNumber(r.amount_cost),
        remarks: r.remarks || "",
        is_invoiced: r.is_invoiced === true,
        other_expenses: this.buildOtherExpensePayload(r),
      }));

      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/update", {
          year: this.year,
          month: this.month,
          items: items,
        })
        .then(() => {
          if (!isCurrent()) return;
          alert(this.invoiceTexts.updated);
          this.callList();
        })
        .catch((error) => this.handleRequestFailure(error, isCurrent))
        .finally(() => {
          this.saving = false;
        });
    },

    // 単価/下限/上限が変わったら → 手入力は意味がなくなるので自動計算へ戻す
    onBaseOrUnit: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.deduct = false;
      r._manual.excess = false;
      r._manual.sales = false;

      this.autoCalcDeductExcess(r);
      this.autoCalcSales(r);
    },

    // 控除/超過/売上 を「入力したら」手動扱いにする
    onDeductInput: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.deduct = true;
      this.autoCalcSales(r);
    },

    onExcessInput: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.excess = true;
      this.autoCalcSales(r);
    },

    onSalesInput: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.sales = true;
    },

    onSettlementInput: function (r) {
      this.autoCalcSales(r);
    },

    // 控除/超過 自動計算（10円単位：控除=切上げ、超過=切捨て、10円未満は0）
    // 控除：単価 / 下限（切上げ）
    // 超過：単価 / 上限（切捨て）
    autoCalcDeductExcess: function (r) {
      const unit = this.toNum(r.unit_price);
      const min = this.toNum(r.base_time_min);
      const max = this.toNum(r.base_time_max);

      if (!(r._manual && r._manual.deduct)) {
        const v = (min > 0) ? (unit / min) : 0;
        r.unit_price_deduct = (v < 10) ? 0 : this.ceil10(v);
      }

      if (!(r._manual && r._manual.excess)) {
        const v = (max > 0) ? (unit / max) : 0;
        r.unit_price_excess = (v < 10) ? 0 : this.floor10(v);
      }
    },

    // 売上 自動計算（手動入力したら固定）
    // 精算=0 → 単価
    // 精算>0 → 単価 + 超過*精算
    // 精算<0 → 単価 + 控除*精算
    autoCalcSales: function (r) {
      if (r._manual && r._manual.sales) return;

      const settlement = this.toNum(r.settlement_time);
      const unit = this.toNum(r.unit_price);
      const deduct = this.toNum(r.unit_price_deduct);
      const excess = this.toNum(r.unit_price_excess);

      if (settlement === 0) {
        r.amount_sales = unit;
        return;
      }
      if (settlement > 0) {
        r.amount_sales = unit + excess * settlement;
        return;
      }
      r.amount_sales = unit + deduct * settlement;
    },

    buildRowspan: function (rows) {
      const out = rows.map((r) => ({
        ...r,
        _showCompany: false,
        _companySpan: 1,
        _showDueDate: false,
        _dueDateSpan: 1,
        _showProject: false,
        _projectSpan: 1,
        _showViewRemarks: false,
        _viewRemarksSpan: 1,
        _invoiceCompanyId: r.company_id || null,
      }));

      let i = 0;
      while (i < out.length) {
        const cid = out[i].company_id;
        let j = i;
        while (j < out.length && out[j].company_id === cid) j++;

        out[i]._showCompany = true;
        out[i]._companySpan = j - i;
        out[i]._showDueDate = true;
        out[i]._dueDateSpan = j - i;
        out[i]._showViewRemarks = true;
        out[i]._viewRemarksSpan = j - i;

        for (let n = i; n < j; n++) {
          out[n]._invoiceCompanyId = cid;
        }

        let k = i;
        while (k < j) {
          const pid = out[k].project_id;
          let m = k;
          while (m < j && out[m].project_id === pid) m++;

          out[k]._showProject = true;
          out[k]._projectSpan = m - k;

          k = m;
        }
        i = j;
      }
      return out;
    },

    buildFormCompanyRowspan: function (rows) {
      const out = rows.map((r) => ({
        ...r,
        _showFormCompany: false,
        _formCompanySpan: 1,
        _showFormDueDate: false,
        _formDueDateSpan: 1,
        _showFormProject: false,
        _formProjectSpan: 1,
        _showFormRemarks: false,
        _formRemarksSpan: 1,
      }));

      let i = 0;
      while (i < out.length) {
        const cid = out[i].company_id;
        let j = i;
        while (j < out.length && out[j].company_id === cid) j++;

        out[i]._showFormCompany = true;
        out[i]._formCompanySpan = j - i;
        out[i]._showFormDueDate = true;
        out[i]._formDueDateSpan = j - i;
        out[i]._showFormRemarks = true;
        out[i]._formRemarksSpan = j - i;

        let k = i;
        while (k < j) {
          const pid = out[k].project_id;
          let m = k;
          while (m < j && out[m].project_id === pid) m++;

          out[k]._showFormProject = true;
          out[k]._formProjectSpan = m - k;

          k = m;
        }

        i = j;
      }
      return out;
    },

    onCompanyDueDateInput: function (r) {
      // 欄が書き換えたのは、その会社の未発行の行（dueDateRow）。その値を、同じ会社の未発行の行にだけ配る
      // （発行済みの請求書に載っている行は変えない）。
      const dueDate = this.dueDateRow(r).due_date || "";
      this.formRows.forEach((row) => {
        if (row.company_id === r.company_id && !row.invoice_id) {
          row.due_date = dueDate;
        }
      });
    },

    onCompanyRemarksInput: function (r) {
      this.formRows.forEach((row) => {
        if (row.company_id === r.company_id) {
          row.remarks = r.remarks || "";
        }
      });
    },

    normalizeCompanyFields: function (rows) {
      const firstByCompany = {};
      // 支払期限は、その会社の未発行の行の値（発行済みの請求書に載っている行は、自分の値のまま送る）。
      const dueDateByCompany = {};

      rows.forEach((r) => {
        if (!Object.prototype.hasOwnProperty.call(firstByCompany, r.company_id)) {
          firstByCompany[r.company_id] = {
            remarks: r.remarks || "",
          };
        }
        if (!r.invoice_id && !Object.prototype.hasOwnProperty.call(dueDateByCompany, r.company_id)) {
          dueDateByCompany[r.company_id] = r.due_date || "";
        }
      });

      return rows.map((r) => ({
        ...r,
        due_date: r.invoice_id ? (r.due_date || "") : dueDateByCompany[r.company_id],
        remarks: firstByCompany[r.company_id].remarks,
      }));
    },

    formRowKey: function (r, idx) {
      return `${r.company_id}-${r.project_id}-${r.user_id}-${idx}`;
    },

    rowKey: function (r, idx) {
      return `${r.id || 0}-${r.company_id}-${r.project_id}-${r.user_id}-${idx}`;
    },

    /** 請求書のファイルを受け取っているボタンの鍵。 */
    invoiceDownloadKey: function (scope, id, companyId) {
      return scope === "user" ? `user:${id}:${companyId}` : `${scope}:${id}`;
    },

    /** その［請求書］が、いまファイルを受け取っている最中か。 */
    isDownloadingInvoice: function (scope, id, companyId) {
      return this.downloadingInvoice !== "" &&
        this.downloadingInvoice === this.invoiceDownloadKey(scope, id, companyId);
    },

    openInvoice: function (scope, id, companyId) {
      // 受け取っている最中は、重ねて頼まない（ボタンも押せなくしてある）。
      if (this.downloadingInvoice !== "") return;
      // 表示している行の請求書なので、見出しの月で頼む（選択欄の月ではない）。
      const params = { year: this.selectYear, month: this.selectMonth, scope: scope };
      if (scope === "company") params.company_id = id;
      if (scope === "project") params.project_id = id;
      if (scope === "user") {
        if (!companyId) {
          alert("請求先の会社を特定できませんでした。再検索してください。");
          return;
        }
        params.user_id = id;
        params.company_id = companyId;
      }

      this.downloadingInvoice = this.invoiceDownloadKey(scope, id, companyId);
      // 受け取ったファイルは、月を変えていても保存する。失敗の案内だけは、頼んだときの画面でだけ出す（R7・監査 RE-3）。
      const isCurrent = this.currentGeneration();

      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/invoice/pdf", {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          /*
           * **blob: の URL を開かない。**
           *
           * URL.createObjectURL が作る blob: には**ファイル名が
           * 乗らない。**ブラウザ内蔵のPDFビューアで開いてから保存を
           * 押すと、名前を決められず一時ファイル（.tmp）になる
           * （2026-09-11 にテスターから報告）。
           *
           * downloadBlobResponse は Content-Disposition の
           * ファイル名を読み、a[download] で保存する。
           *
           * **名前は back が付ける。**一括ダウンロード（ZIP）の中身と同じ
           * 「{請求年月}_請求書({稼働月}{スタッフ名})_{請求先}様.pdf」。
           * **ここで別の形の名前を作らない。**2026-09-11 に画面側で
           * 「請求書_{年月}.pdf」を作り、元の規則を上書きしていた。
           *
           * 控えの名前は、back が名前を出さなかったときだけ使う。
           * この画面の一括ダウンロード（sales_invoice_{年月}.zip）と揃える。
           */
          downloadBlobResponse(
            res,
            `sales_invoice_${params.year}${String(params.month).padStart(2, "0")}.pdf`
          );
        })
        .catch((error) => {
          // 記録の通信は待たない（待つと、そのあいだボタンが処理中のまま戻らない）。案内は先に出る（頼んだときの画面でだけ）。
          reportDownloadFailure(axios, error, "SALES_DOWNLOAD_FAILED", isCurrent);
        })
        .finally(() => {
          this.downloadingInvoice = "";
        });
    },

    /**
     * 発行した請求書の紙（下の表の［請求書］）。請求書は、記録の番号で指す。
     * 記録の写しから描くので、何度開いても同じ紙。名前は back が付ける（確認用と同じ規則）。
     */
    openIssuedInvoice: function (inv) {
      // 受け取っている最中は、重ねて頼まない（ボタンも押せなくしてある）。
      if (this.downloadingInvoice !== "") return;
      this.downloadingInvoice = this.invoiceDownloadKey("issued", inv.invoice_id);
      // 控えの名前は、頼んだときの月で付ける（待つあいだに月を変えても）。
      const fallbackName = `sales_invoice_${this.selectYear}${String(this.selectMonth).padStart(2, "0")}.pdf`;
      // 失敗の案内は、頼んだときの画面でだけ出す（R7・監査 RE-3）。
      const isCurrent = this.currentGeneration();
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/invoice/issued-pdf", {
          params: { invoice_id: inv.invoice_id },
          responseType: "blob",
        })
        .then((res) => {
          downloadBlobResponse(res, fallbackName);
        })
        .catch((error) => {
          // 記録の通信は待たない（待つと、そのあいだボタンが処理中のまま戻らない）。
          reportDownloadFailure(axios, error, "SALES_DOWNLOAD_FAILED", isCurrent);
        })
        .finally(() => {
          this.downloadingInvoice = "";
        });
    },

    /**
     * 入力を数値として読む。**読めなければ 0 ではなく null を返す。**
     *
     * 全角数字「１０００」や「1,000」「10円」は Number では NaN になる。
     * これを 0 に落として保存すると、単価や控除が消えた請求書が
     * 誰にも告げず出来上がる。有給付与月が 0 で保存されたのと同じ形。
     *
     * 空欄は 0 として読む。**入れていない**のと**読めない文字が入っている**
     * のは別の話で、後者だけを止めたい。
     */
    readNumber: function (v) {
      if (v === null || v === undefined) return 0;
      const text = String(v).trim();
      if (text === "") return 0;
      const n = Number(text);
      return Number.isFinite(n) ? n : null;
    },

    /**
     * 表示と自動計算のためだけに、読めない値を 0 とみなす。
     *
     * **保存の本文には使わない。**保存は readNumber で読み、読めない行は
     * missingFields が押させない。ここで 0 に落としたものを送ると、
     * 画面には全角数字が残ったまま DB だけ 0 になる。
     */
    toNum: function (v) {
      const n = this.readNumber(v);
      return n === null ? 0 : n;
    },

    /** 押せない理由に出す行の呼び名。表に出ている言葉で書く。 */
    rowLabel: function (r) {
      const who = r.user_name || r.staff_name || "担当者不明";
      const company = r.company_name || "会社名なし";
      return `${who}（${company}）`;
    },

    /**
     * 保存の入口でも、ボタンと同じものを見て止める。
     *
     * ボタンの :disabled は表示の都合でいつでも外れ得るし、
     * **0 で保存されたものは後から見分けが付かない。**
     */
    blockedByMissingFields: function () {
      if (!this.missingFields.length) return false;
      this.errors = this.missingFields.slice();
      this.scrollToErrors();
      return true;
    },

    floor10: function (v) {
      const n = Number(v);
      if (!Number.isFinite(n) || n <= 0) return 0;
      return Math.floor(n / 10) * 10;
    },

    ceil10: function (v) {
      const n = Number(v);
      if (!Number.isFinite(n) || n <= 0) return 0;
      return Math.ceil(n / 10) * 10;
    },

    formatNum: function (v) {
      const n = this.toNum(v);
      return n.toLocaleString();
    },
    normalizeOtherExpenses: function (expenses) {
      if (!Array.isArray(expenses) || expenses.length === 0) {
        return [];
      }
      return expenses.map((ex) => ({
        item_name: ex.item_name || "",
        qty: (ex.qty ?? 1),
        unit: ex.unit || "式",
        unit_price: (ex.unit_price ?? 0),
        amount: (ex.amount ?? 0),
        remarks: ex.remarks || "",
      }));
    },

    buildOtherExpensePayload: function (r) {
      return (r.other_expenses || []).map((ex) => ({
        item_name: ex.item_name || "",
        qty: this.readNumber(ex.qty),
        unit: ex.unit || "式",
        unit_price: this.readNumber(ex.unit_price),
        amount: this.readNumber(ex.amount),
        remarks: ex.remarks || "",
      }));
    },

    newOtherExpenseRow: function () {
      return {
        item_name: "",
        qty: 1,
        unit: "式",
        unit_price: 0,
        amount: 0,
        remarks: "",
      };
    },
    addOtherExpense: function (r) {
      if (!Array.isArray(r.other_expenses)) {
        r.other_expenses = [];
      }
      r.other_expenses.push(this.newOtherExpenseRow());
    },
    removeOtherExpense: function (r, idx) {
      if (!Array.isArray(r.other_expenses)) {
        return;
      }
      r.other_expenses.splice(idx, 1);
    },
    expenseRowKey: function (r, idx) {
      return `${r.id || 0}-${r.company_id}-${r.project_id}-${r.user_id}-expense-${idx}`;
    },
    downloadAllCompanyInvoices: function () {
      // 束ねるのは、その月の有効な発行済みの請求書（サーバが記録から選ぶ。未発行の確認用は入らない）。
      if (this.issuedInvoiceCount === 0) {
        alert(this.invoiceTexts.nothingToDownload);
        return;
      }
      // 受け取っている最中は、重ねて頼まない（ボタンも押せなくしてある）。
      if (this.downloadingInvoice !== "") return;
      this.downloadingInvoice = "zip";
      // 表示している月の請求書なので、見出しの月で頼む。名前も頼んだときの月で付ける（待つあいだに月を変えても）。
      const year = this.selectYear;
      const month = this.selectMonth;
      // 失敗の案内は、頼んだときの画面でだけ出す（R7・監査 RE-3）。
      const isCurrent = this.currentGeneration();

      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/invoice/zip", {
          year: year,
          month: month,
        }, {
          responseType: "blob",
        })
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `sales_invoice_${year}${String(month).padStart(2, "0")}.zip`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          // 記録の通信は待たない（待つと、そのあいだボタンが処理中のまま戻らない）。
          reportDownloadFailure(axios, error, "SALES_DOWNLOAD_FAILED", isCurrent);
        })
        .finally(() => {
          this.downloadingInvoice = "";
        });
    },
    onProjectNameInput: function (r) {
      // 欄が書き換えたのは、そのプロジェクトの未発行の行（projectNameRow）。その値を、同じプロジェクトの
      // 未発行の行にだけ配る（発行済みの請求書に載っている行は変えない）。
      const projectName = this.projectNameRow(r).project_name || "";
      this.formRows.forEach((row) => {
        if (row.project_id === r.project_id && !row.invoice_id) {
          row.project_name = projectName;
        }
      });
    },
  },

  computed: {
    /**
     * 数字として読めない入力。**行と項目を名指しする。**
     *
     * 「入力に誤りがあります」だけでは、100行の表のどこを直せばよいか
     * 分からない。誰の・どの列かまで書く。
     */
    unreadableNumbers: function () {
      const found = [];

      this.formRows.forEach((r) => {
        const who = this.rowLabel(r);

        NUMBER_FIELDS.forEach((field) => {
          if (this.readNumber(r[field.key]) === null) {
            found.push(`${who}の「${field.label}」が数字として読めません`);
          }
        });

        (r.other_expenses || []).forEach((ex, exIdx) => {
          EXPENSE_NUMBER_FIELDS.forEach((field) => {
            if (this.readNumber(ex[field.key]) === null) {
              found.push(`${who}のその他経費${exIdx + 1}行目「${field.label}」が数字として読めません`);
            }
          });
        });
      });

      return found;
    },

    /**
     * 発行ONなのに支払期限が空の会社。
     *
     * **発行OFFの行まで必須にすると締めが止まる。**請求書を出さない行に
     * 支払期限は要らない。支払期限は会社単位で揃えているので、会社名で挙げる。
     */
    dueDateMissingCompanies: function () {
      const found = [];

      this.formRows.forEach((r) => {
        if (r.is_invoiced !== true) return;
        if (String(r.due_date || "").trim() !== "") return;

        const company = r.company_name || "会社名なし";
        if (found.indexOf(company) < 0) found.push(company);
      });

      return found;
    },

    /**
     * 金額設定が1件も無い人（新規で、サーバが単価・原価を null で返した行）。
     * 押せない理由に出すので、行の呼び名（名前と会社名）で返す。
     *
     * **発行OFFの行も止める。**発行しなくても売上は確定値として残り、
     * 集計の「金額未設定」の警告が消える。0円で登録したいなら、
     * プロジェクト金額設定で 0円を入れれば通る（0円は未設定ではない）。
     */
    rateUnsetMembers: function () {
      const found = [];

      this.formRows.forEach((r) => {
        if (r._rateUnset !== true) return;
        const who = this.rowLabel(r);
        if (found.indexOf(who) < 0) found.push(who);
      });

      return found;
    },

    /**
     * 押せない理由の一覧。
     *
     * **登録・更新ボタンの :disabled と、ここは同じ computed
     * （unreadableNumbers・dueDateMissingCompanies）を見ている。**
     * 片方だけ直すと「あと0つです」と出ているのに押せない、という
     * さらに分かりにくい形になる。
     *
     * 名前と書き方（`missingFields ()`）は他の入力画面と揃えてある。
     * **変えると、押せない理由を全画面まとめて見る検査が拾わなくなる。**
     */
    missingFields () {
      /*
       * 対象行が0件のときは、表の代わりに次の一手（所属と金額設定の確認）を
       * 出している。ここで数え上げても、**この画面では直しようがない。**
       */
      if (!this.formRows.length) return [];

      const missing = [];
      this.dueDateMissingCompanies.forEach((company) => {
        missing.push(`支払期限（${company}）— 発行ONの行があります`);
      });
      this.rateUnsetMembers.forEach((who) => {
        missing.push(`${who}のプロジェクト金額設定が未登録です。対象月の「プロジェクト金額設定」で基本請求額と月額原価を設定後、［検索］を再実行してください。`);
      });
      this.unreadableNumbers.forEach((what) => {
        missing.push(what);
      });
      return missing;
    },

    /**
     * 請求書を出力（PDF・ZIP）・発行できる人か。**サーバと同じ条件**（契約に請求書の
     * 機能があり、請求書の管理の権限を持つ）。判定は accessPolicy.js の1か所に置いてある。
     * 権限と契約を確かめられないときは出さない。
     *
     * ［請求書］［一括ダウンロード］［発行］［一括発行］・その使い方の説明・自社の情報が
     * 空のときの案内を、これ1つで出し分ける。出力と発行で条件を分けない
     * （サーバが同じ条件で通す・断るので、分けると片方だけ「押すと必ず断られる」ボタンになる）。
     */
    canOutputAndIssueInvoice: function () {
      return canOutputAndIssueSalesInvoice(this.accessContext);
    },

    /**
     * 売上の行を登録・更新・作り直しできる人か。**サーバと同じ条件**（契約に売上の機能が
     * あり、売上情報の管理の権限を持つ）。判定は accessPolicy.js の1か所に置いてある。
     * 権限と契約を確かめられないときは出さない。
     *
     * ［最新を取り込んで再作成］［更新］と、新規登録の表・更新の表・再作成の表への入口を、
     * これ1つで出し分ける（［登録］は新規登録の表の中にあるので、表ごと出ない）。
     * 上の canOutputAndIssueInvoice（請求書の出力・発行）とは別の権限で、片方だけを
     * 持つ人がいる。
     */
    canEditSales: function () {
      return canEditSalesRecords(this.accessContext);
    },

    /** 有効な（取り消していない）発行済みの請求書の枚数。0 なら、一括ダウンロードで束ねる物が無い。 */
    issuedInvoiceCount: function () {
      return (this.invoices || []).filter((inv) => inv.status === "ISSUED").length;
    },

    /** プロジェクト金額設定を開ける人か。開ける人にだけ、金額設定へのリンクを出す。 */
    canOpenProjectRate: function () {
      return !!this.accessContext && canAccessPath(this.accessContext, this.projectRatePath);
    },

    /** 取り消しの小窓に出す、相手の名前と請求番号。 */
    voidDialogTargetName: function () {
      const inv = this.voidDialog;
      if (!inv) return "";
      return [inv.bill_to_name, inv.invoice_no].filter((one) => !!one).join(" ");
    },

    /** 自社設定を開ける人か。開ける人には、入れる画面へのリンクを出す。 */
    canOpenCompanySetting: function () {
      return !!this.accessContext && canAccessPath(this.accessContext, "/setting/info");
    },

    /** まだ発行していない行がある会社。一括の発行で送る。上の表に出ている会社。 */
    unissuedCompanyIds: function () {
      return this.viewRows
        .filter((r) => r._showCompany)
        .map((r) => r.company_id);
    },

    /** 請求書に載せる自社の情報で、まだ空の項目の名前（自社設定の欄と同じ名前）。 */
    issuerMissingLabels: function () {
      return (this.issuerMissing || []).map((key) => invoiceIssuerLabel(key));
    },

    issuerMissingNotice: function () {
      return invoiceIssuerMissingNotice(this.issuerMissingLabels);
    },

    /** 確かめの小窓の本文。1件のときと一括のとき（何社ぶんかを出す）で変わる。 */
    issueDialogBody: function () {
      const dialog = this.issueDialog;
      if (!dialog) return "";
      return dialog.all
        ? this.invoiceTexts.issueDialogBodyAll(dialog.targets.length)
        : this.invoiceTexts.issueDialogBodyOne;
    },

    /** 確かめの小窓に出す、発行する相手の名前。一括のときは出さない（件数が本文に入る）。 */
    issueDialogTargetName: function () {
      return this.issueDialog ? this.issueDialog.targetName : "";
    },

    /** 理由の文言と、表の下のボタンに出す名前。更新の表は「更新」、新規の表と再作成の表は「登録」。 */
    saveActionName: function () {
      return this.mode === "edit" ? "更新" : "登録";
    },

    /** 更新・再作成の表の進めるボタンで、送る物があるか（再作成は、差し替える明細だけでもよい）。 */
    hasSomethingToSave: function () {
      if (this.formRows.length > 0) return true;
      return this.mode === "recreate" && this.recreateReplaceIds.length > 0;
    },

    totalUnitPrice: function () {
      return (this.rows || [])
        .filter((r) => r.is_invoiced === true)
        .reduce((sum, r) => sum + this.toNum(r.unit_price), 0);
    },
    totalAmountSales: function () {
      return (this.rows || [])
        .filter((r) => r.is_invoiced === true)
        .reduce((sum, r) => sum + this.toNum(r.amount_sales), 0);
    },
  },
};
</script>

<style scoped>
td,
th {
  white-space: nowrap;
  vertical-align: middle;
}
.text-right {
  text-align: right;
}
.cell-date {
  min-width: 165px;
}
.cell-staff {
  min-width: 160px;
}
.project-name-input {
  min-width: 220px;
}
.cell-num {
  min-width: 90px;
}
.cell-money {
  min-width: 120px;
}
.cell-remarks {
  min-width: 220px;
}
.cell-other-expenses {
  min-width: 520px;
  vertical-align: top;
}
.expense-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.expense-item {
  min-width: 120px;
}
.expense-qty {
  min-width: 70px;
}
.expense-unit {
  min-width: 70px;
}
.expense-price {
  min-width: 90px;
}
.expense-amount {
  min-width: 90px;
}
.expense-remarks {
  min-width: 140px;
}
.expense-view-row {
  margin-bottom: 8px;
  white-space: normal;
}
/* ［請求書］と［発行］を横に並べる。名前が長い行でもボタンを縮めない。 */
.invoice-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
/* 発行の状態（発行済みの番号と発行日・未発行）。名前の下に小さく出す。 */
.invoice-state {
  margin-top: 4px;
  font-size: 12px;
  color: #5c6873;
}
/* 2つの表の見出し（まだ発行していない分／発行した請求書）。 */
.sales-section-title {
  margin: 12px 0 8px;
  font-size: 16px;
  font-weight: 600;
}
/*
 * 合計・［最新を取り込んで再作成］・［更新］の行。狭い幅（576px 未満）では、横に並べずに縦に積む
 * （合計 →（作り直す分が無かったときは、そのこと）→［最新を取り込んで再作成］→［更新］）。
 * PC の幅の見た目は変えない。
 */
@media (max-width: 575.98px) {
  .sales-summary-row {
    flex-direction: column;
    align-items: flex-end !important;
  }
  .sales-summary-row > * {
    margin-right: 0 !important;
  }
  .sales-summary-row > * + * {
    margin-top: 8px;
  }
  .sales-summary-row .recreate-nothing {
    max-width: 100%;
  }
}
/* ［最新を取り込んで再作成］を押したが、作り直す分が無かったとき。ボタンの横に、折り返して出す。 */
.recreate-nothing {
  max-width: 420px;
  font-size: 12px;
  color: #5c6873;
  white-space: normal;
  text-align: right;
}
/* 発行した請求書の表。名前と状態（取り消しの理由）は、長ければ折り返す（スマホ幅でも読める）。 */
.issued-table .issued-cell-name,
.issued-table .issued-cell-status {
  white-space: normal;
  overflow-wrap: anywhere;
  min-width: 140px;
}
.issued-row--voided td {
  color: #8a93a2;
}
/* 更新の表で、請求書に載っている行に出す理由。 */
.locked-row-note {
  margin-top: 4px;
  max-width: 260px;
  font-size: 12px;
  color: #5c6873;
  white-space: normal;
}
.no-unissued td {
  color: #5c6873;
}
.sales-notice {
  white-space: normal;
}
/* 取り消しの小窓の、理由の欄。 */
.void-dialog__label {
  display: block;
  margin: 12px 0 4px;
  font-weight: 600;
}
.void-dialog__error {
  margin-top: 4px;
  font-size: 13px;
  color: #e55353;
}
.invoice-guide {
  margin: 0 0 8px;
  font-size: 13px;
  color: #5c6873;
}
/* 再作成の表の上の説明。見出しのすぐ下に、折り返して出す。 */
.recreate-guide {
  margin: 8px 0;
  white-space: normal;
}
/* ［登録］で削除される明細の一覧。行の頭の「・」は文に入っている（Gemini の Z2）ので、点を重ねない。 */
.recreate-removed {
  white-space: normal;
}
.recreate-removed-list {
  padding-left: 0;
  list-style: none;
  overflow-wrap: anywhere;
}
/* 確かめの小窓の中。発行する相手の名前は、本文より目立たせる。長い名前は折り返す。 */
.issue-dialog__target {
  margin: 0 0 8px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.issue-dialog__body {
  margin: 0;
  line-height: 1.7;
}
</style>
